// @ts-nocheck
/* eslint-disable */
// DO NOT EDIT — generated by `just analytics-types` (quicktype). Excluded from strict type-checking per ADR-008.
// To parse this data:
//
//   import { Convert, AddApartmentBlockRequest, Address, AddSavedGridViewRequest, AddSavedGridViewResponse, AddTagResponse, Apartment, ApartmentOwner, ApartmentStats, DashboardLayout, GetAddressesResponse, GetAddressesWithCountsResponse, GetAirbnbReviewsResponse, GetAllTagsResponse, GetAllUsersResponse, GetApartmentBlocks, GetApartmentGroupsResponse, GetApartmentOwnerResponse, GetApartmentOwnersResponse, GetApartmentResponse, GetApartmentsResponse, GetApartmentStatTrends, GetBltStatsResponse, GetBookingPaceResponse, GetDashboardLayoutsResponse, GetExpenseCategoriesResponse, GetExpensesResponse, GetGroupedByExpensesGroupResponse, GetGroupedByExpensesResponse, GetHostHubMappingStatusResponse, GetHostHubRentalsResponse, GetHostHubSyncIssuesResponse, GetManagementFeeRatioResponse, GetManagementFeeRatiosResponse, GetMonthlyApartmentStatsResponse, GetMunicipalitySectionsResponse, GetMunicipalitySectionsWithCountsResponse, GetNeedsRefileResponse, GetNeteraAccountsResponse, GetNeteraCredentialLabelsResponse, GetOccupanciesResponse, GetOverviewStatsResponse, GetOwnerAirbnbReviewsResponse, GetOwnerGroupsResponse, GetOwnerGroupsWithCountsResponse, GetPayoutRatioResponse, GetPayoutRatiosResponse, GetPayoutsReponse, GetPayoutStatsResponse, GetPeriodBreakdownStatsResponse, GetReservationDigestResponse, GetReservationHistoryResponse, GetReservationsResponse, GetReviewPerformanceResponse, GetSavedGridViewsResponse, GetShortTermRegistryRecordsResponse, GetStatsForApartmentsResponse, GetStatsForApartmentsWithDates, GetStatsForGroupsResponse, GetStrOwnersResponse, GetTagsWithCountsResponse, GetTotalStatsResponse, GetUserResponse, GetYearsInOperationResponse, GridView, GroupStats, ImportExpensesResponse, ManagementFeeRatio, MunicipalitySection, MunicipalitySectionInUseError, MunicipalitySectionWithCount, NeteraAccount, OwnerGroup, OwnerGroupInUseError, OwnerGroupWithCount, PayoutRatio, PayoutStat, ReconciliationResponse, Tag, TagInUseError, TagWithCount, TotalStats, UploadToMyDataResponse, UploadToShortTermRegistryResponse, UpsertDashboardLayoutResponse, User, AddMunicipalitySectionRequest, AddOwnerGroupRequest, AddTagRequest, CreateNeteraAccountRequest, UpdateMunicipalitySectionRequest, UpdateOwnerGroupRequest, UpdateTagRequest, UpsertDashboardLayoutRequest } from "./file";
//
//   const addApartmentBlockRequest = Convert.toAddApartmentBlockRequest(json);
//   const address = Convert.toAddress(json);
//   const addSavedGridViewRequest = Convert.toAddSavedGridViewRequest(json);
//   const addSavedGridViewResponse = Convert.toAddSavedGridViewResponse(json);
//   const addTagResponse = Convert.toAddTagResponse(json);
//   const apartment = Convert.toApartment(json);
//   const apartmentOwner = Convert.toApartmentOwner(json);
//   const apartmentStats = Convert.toApartmentStats(json);
//   const dashboardLayout = Convert.toDashboardLayout(json);
//   const getAddressesResponse = Convert.toGetAddressesResponse(json);
//   const getAddressesWithCountsResponse = Convert.toGetAddressesWithCountsResponse(json);
//   const getAirbnbReviewsResponse = Convert.toGetAirbnbReviewsResponse(json);
//   const getAllTagsResponse = Convert.toGetAllTagsResponse(json);
//   const getAllUsersResponse = Convert.toGetAllUsersResponse(json);
//   const getApartmentBlocks = Convert.toGetApartmentBlocks(json);
//   const getApartmentGroupsResponse = Convert.toGetApartmentGroupsResponse(json);
//   const getApartmentOwnerResponse = Convert.toGetApartmentOwnerResponse(json);
//   const getApartmentOwnersResponse = Convert.toGetApartmentOwnersResponse(json);
//   const getApartmentResponse = Convert.toGetApartmentResponse(json);
//   const getApartmentsResponse = Convert.toGetApartmentsResponse(json);
//   const getApartmentStatTrends = Convert.toGetApartmentStatTrends(json);
//   const getBltStatsResponse = Convert.toGetBltStatsResponse(json);
//   const getBookingPaceResponse = Convert.toGetBookingPaceResponse(json);
//   const getDashboardLayoutsResponse = Convert.toGetDashboardLayoutsResponse(json);
//   const getExpenseCategoriesResponse = Convert.toGetExpenseCategoriesResponse(json);
//   const getExpensesResponse = Convert.toGetExpensesResponse(json);
//   const getGroupedByExpensesGroupResponse = Convert.toGetGroupedByExpensesGroupResponse(json);
//   const getGroupedByExpensesResponse = Convert.toGetGroupedByExpensesResponse(json);
//   const getHostHubMappingStatusResponse = Convert.toGetHostHubMappingStatusResponse(json);
//   const getHostHubRentalsResponse = Convert.toGetHostHubRentalsResponse(json);
//   const getHostHubSyncIssuesResponse = Convert.toGetHostHubSyncIssuesResponse(json);
//   const getManagementFeeRatioResponse = Convert.toGetManagementFeeRatioResponse(json);
//   const getManagementFeeRatiosResponse = Convert.toGetManagementFeeRatiosResponse(json);
//   const getMonthlyApartmentStatsResponse = Convert.toGetMonthlyApartmentStatsResponse(json);
//   const getMunicipalitySectionsResponse = Convert.toGetMunicipalitySectionsResponse(json);
//   const getMunicipalitySectionsWithCountsResponse = Convert.toGetMunicipalitySectionsWithCountsResponse(json);
//   const getNeedsRefileResponse = Convert.toGetNeedsRefileResponse(json);
//   const getNeteraAccountsResponse = Convert.toGetNeteraAccountsResponse(json);
//   const getNeteraCredentialLabelsResponse = Convert.toGetNeteraCredentialLabelsResponse(json);
//   const getOccupanciesResponse = Convert.toGetOccupanciesResponse(json);
//   const getOverviewStatsResponse = Convert.toGetOverviewStatsResponse(json);
//   const getOwnerAirbnbReviewsResponse = Convert.toGetOwnerAirbnbReviewsResponse(json);
//   const getOwnerGroupsResponse = Convert.toGetOwnerGroupsResponse(json);
//   const getOwnerGroupsWithCountsResponse = Convert.toGetOwnerGroupsWithCountsResponse(json);
//   const getPayoutRatioResponse = Convert.toGetPayoutRatioResponse(json);
//   const getPayoutRatiosResponse = Convert.toGetPayoutRatiosResponse(json);
//   const getPayoutsReponse = Convert.toGetPayoutsReponse(json);
//   const getPayoutStatsResponse = Convert.toGetPayoutStatsResponse(json);
//   const getPeriodBreakdownStatsResponse = Convert.toGetPeriodBreakdownStatsResponse(json);
//   const getReservationDigestResponse = Convert.toGetReservationDigestResponse(json);
//   const getReservationHistoryResponse = Convert.toGetReservationHistoryResponse(json);
//   const getReservationsResponse = Convert.toGetReservationsResponse(json);
//   const getReviewPerformanceResponse = Convert.toGetReviewPerformanceResponse(json);
//   const getSavedGridViewsResponse = Convert.toGetSavedGridViewsResponse(json);
//   const getShortTermRegistryRecordsResponse = Convert.toGetShortTermRegistryRecordsResponse(json);
//   const getStatsForApartmentsResponse = Convert.toGetStatsForApartmentsResponse(json);
//   const getStatsForApartmentsWithDates = Convert.toGetStatsForApartmentsWithDates(json);
//   const getStatsForGroupsResponse = Convert.toGetStatsForGroupsResponse(json);
//   const getStrOwnersResponse = Convert.toGetStrOwnersResponse(json);
//   const getTagsWithCountsResponse = Convert.toGetTagsWithCountsResponse(json);
//   const getTotalStatsResponse = Convert.toGetTotalStatsResponse(json);
//   const getUserResponse = Convert.toGetUserResponse(json);
//   const getYearsInOperationResponse = Convert.toGetYearsInOperationResponse(json);
//   const gridView = Convert.toGridView(json);
//   const groupStats = Convert.toGroupStats(json);
//   const importExpensesResponse = Convert.toImportExpensesResponse(json);
//   const managementFeeRatio = Convert.toManagementFeeRatio(json);
//   const municipalitySection = Convert.toMunicipalitySection(json);
//   const municipalitySectionInUseError = Convert.toMunicipalitySectionInUseError(json);
//   const municipalitySectionWithCount = Convert.toMunicipalitySectionWithCount(json);
//   const neteraAccount = Convert.toNeteraAccount(json);
//   const ownerGroup = Convert.toOwnerGroup(json);
//   const ownerGroupInUseError = Convert.toOwnerGroupInUseError(json);
//   const ownerGroupWithCount = Convert.toOwnerGroupWithCount(json);
//   const payoutRatio = Convert.toPayoutRatio(json);
//   const payoutStat = Convert.toPayoutStat(json);
//   const reconciliationResponse = Convert.toReconciliationResponse(json);
//   const tag = Convert.toTag(json);
//   const tagInUseError = Convert.toTagInUseError(json);
//   const tagWithCount = Convert.toTagWithCount(json);
//   const totalStats = Convert.toTotalStats(json);
//   const uploadToMyDataResponse = Convert.toUploadToMyDataResponse(json);
//   const uploadToShortTermRegistryResponse = Convert.toUploadToShortTermRegistryResponse(json);
//   const upsertDashboardLayoutResponse = Convert.toUpsertDashboardLayoutResponse(json);
//   const user = Convert.toUser(json);
//   const addMunicipalitySectionRequest = Convert.toAddMunicipalitySectionRequest(json);
//   const addOwnerGroupRequest = Convert.toAddOwnerGroupRequest(json);
//   const addTagRequest = Convert.toAddTagRequest(json);
//   const createNeteraAccountRequest = Convert.toCreateNeteraAccountRequest(json);
//   const updateMunicipalitySectionRequest = Convert.toUpdateMunicipalitySectionRequest(json);
//   const updateOwnerGroupRequest = Convert.toUpdateOwnerGroupRequest(json);
//   const updateTagRequest = Convert.toUpdateTagRequest(json);
//   const upsertDashboardLayoutRequest = Convert.toUpsertDashboardLayoutRequest(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected interface, even if the JSON is valid.

export interface AddApartmentBlockRequest {
    apartmentId: number;
    startDate:   Date;
    endDate:     Date;
    notes:       string;
}

export interface AddSavedGridViewRequest {
    id?:          number;
    viewName:     string;
    gridName:     string;
    columnStates: ColumnState[];
    filterModel?: { [key: string]: any };
}

export interface ColumnState {
    aggFunc:       null | string;
    colId:         string;
    flex:          number | null;
    hide:          boolean;
    pinned:        Pinned | null;
    pivot:         boolean;
    pivotIndex:    number | null;
    rowGroup:      boolean;
    rowGroupIndex: number | null;
    sort:          Sort | null;
    sortIndex:     number | null;
    width:         number;
    [property: string]: any;
}

export enum Pinned {
    Left = "left",
    Right = "right",
}

export enum Sort {
    Asc = "asc",
    Desc = "desc",
}

export interface AddSavedGridViewResponse {
    gridView: GridView;
    [property: string]: any;
}

export interface GridView {
    columnStates: ColumnState[];
    filterModel?: { [key: string]: any };
    gridName:     string;
    id:           number;
    viewName:     string;
    [property: string]: any;
}

export interface AddTagResponse {
    tag: AddTagResponseTag;
}

export interface AddTagResponseTag {
    id:   number;
    name: string;
}

export interface GetAddressesResponse {
    addresses: Address[];
}

export interface Address {
    canonical:             string;
    id:                    number;
    municipalitySectionId: number;
    number:                string;
    postalCode:            string;
    street:                string;
}

export interface GetAddressesWithCountsResponse {
    addresses: AddressWithApartments[];
}

export interface AddressWithApartments {
    apartments:            ApartmentAtAddress[];
    canonical:             string;
    id:                    number;
    municipalitySectionId: number;
    number:                string;
    postalCode:            string;
    street:                string;
}

export interface ApartmentAtAddress {
    apartmentId:   number;
    apartmentName: string;
}

export interface GetAirbnbReviewsResponse {
    reviews: AirbnbReview[];
}

export interface AirbnbReview {
    id:               number;
    apartmentId:      number;
    date:             Date;
    numberOfReviews:  number;
    averageRating:    number;
    cleanliness:      number | null;
    accuracy:         number | null;
    communication:    number | null;
    checkIn:          number | null;
    value:            number | null;
    location:         number | null;
    updateInProgress: boolean;
}

export interface GetAllTagsResponse {
    tags: GetAllTagsResponseTag[];
}

export interface GetAllTagsResponseTag {
    id:   number;
    name: string;
}

export interface GetAllUsersResponse {
    users: User[];
}

export interface User {
    id:              number;
    givenName:       string;
    lastName:        string;
    email:           string;
    profileImageUri: string;
    isAdmin:         boolean;
    visibleOwners:   number[];
    lastVisited?:    Date;
}

export interface GetApartmentBlocks {
    apartmentBlocks: ApartmentBlockCalendarElement[];
}

export interface ApartmentBlockCalendarElement {
    apartmentId?: number;
    endDate:      Date;
    id?:          number;
    notes?:       string;
    origin:       string;
    reason:       string;
    startDate:    Date;
    title:        string;
}

export interface GetApartmentGroupsResponse {
    groups: ApartmentGroup[];
}

export interface ApartmentGroup {
    description: string;
    id:          number;
    name:        string;
}

export interface GetApartmentOwnerResponse {
    owner: ApartmentOwner;
}

export interface ApartmentOwner {
    fullName:       string;
    id:             number;
    taxId?:         string;
    taxisPassword?: string;
    taxisUserName?: string;
}

export interface GetApartmentOwnersResponse {
    owners: ApartmentOwner[];
}

export interface GetApartmentResponse {
    apartment: Apartment;
}

export interface Apartment {
    address?:                               string;
    addressId?:                             number | null;
    airbnbUrl?:                             string;
    atak?:                                  string;
    bookingUrl?:                            string;
    categoryId:                             number;
    checkInFeeRate:                         number;
    dateAdded:                              Date;
    dateRemoved?:                           Date;
    disinfectionCertificateNumber?:         string;
    disinfectionDate?:                      Date;
    electricityCertificateTerminationDate?: Date;
    electricityCompany?:                    string;
    electricityRf?:                         string;
    electricitySupplyId?:                   string;
    energyCertificateIssuanceDate?:         Date;
    eydapRegistryId?:                       string;
    eydapSupplyId?:                         string;
    fireExtinguisherRefillCertificateDate?: Date;
    floor?:                                 number;
    groupId:                                number;
    hosthubExcluded?:                       boolean;
    hosthubRentalId?:                       string;
    id:                                     number;
    imageUrl?:                              string;
    initialTaxisRentalAgreement?:           string;
    insuranceCompany?:                      string;
    insuranceContractId?:                   string;
    internetCompany?:                       string;
    internetLine?:                          string;
    internetPassword?:                      string;
    internetUsername?:                      string;
    isExemptFromErpUpload:                  boolean;
    latestRentalTaxisAgreement?:            string;
    municipalitySectionId:                  number;
    name:                                   string;
    neteraCredentialsId?:                   number | null;
    numberOfBeds?:                          number;
    ownerGroupId:                           number;
    ownerIds:                               number[];
    shortName:                              string;
    shortTermPropertyId?:                   number;
    shortTermRegistryId:                    string;
    squareMeters?:                          number;
    strOwnerId?:                            number | null;
    tagIds?:                                number[];
    tags?:                                  ApartmentTag[];
}

export interface ApartmentTag {
    id:   number;
    name: string;
}

export interface GetApartmentsResponse {
    apartments: Apartment[];
}

export interface GetApartmentStatTrends {
    apartmentStatTrends: ApartmentStatTrend[];
}

export interface ApartmentStatTrend {
    apartmentId:                 number;
    daysAvailable:               number;
    daysAvailablePreviousPeriod: number;
    daysAvailablePreviousYear:   number;
    daysBooked:                  number;
    daysBookedPreviousPeriod:    number;
    daysBookedPreviousYear:      number;
    grossAdr:                    number;
    grossAdrPreviousPeriod:      number;
    grossAdrPreviousYear:        number;
    grossIncome:                 number;
    grossIncomePreviousPeriod:   number;
    grossIncomePreviousYear:     number;
    netAdr:                      number;
    netAdrPreviousPeriod:        number;
    netAdrPreviousYear:          number;
    netIncome:                   number;
    netIncomePreviousPeriod:     number;
    netIncomePreviousYear:       number;
    numberOfVisits:              number;
    occupancy:                   number;
    occupancyPreviousPeriod:     number;
    occupancyPreviousYear:       number;
    payout:                      number;
    payoutPreviousPeriod:        number;
    payoutPreviousYear:          number;
    payoutRatio:                 number;
    payoutRatioPreviousPeriod:   number;
    payoutRatioPreviousYear:     number;
}

export interface GetBltStatsResponse {
    bltStats: BltStatsItem[];
}

export interface BltStatsItem {
    apartmentId:      number;
    grossIncome:      number;
    netIncome:        number;
    daysBooked:       number;
    bookingsReceived: number;
    netAdr:           number;
    grossAdr:         number;
    leadDaysGroup:    string;
}

export interface GetBookingPaceResponse {
    bookingPace: BookingPaceItem[];
    endDate:     Date;
    startDate:   Date;
}

export interface BookingPaceItem {
    apartmentId:       number;
    groupId:           number;
    platformId:        number;
    grossIncome:       number;
    netIncome:         number;
    daysBooked:        number;
    futureDaysBooked:  number;
    bookingsReceived:  number;
    futureGrossIncome: number;
    futureNetIncome:   number;
    cancelledBookings: number;
    cancelledDays:     number;
}

export interface GetDashboardLayoutsResponse {
    layouts: DashboardLayout[];
}

export interface DashboardLayout {
    dashboardId: string;
    id:          number;
    layout:      { [key: string]: any };
    layoutName:  string;
    userId:      number;
}

export interface GetExpenseCategoriesResponse {
    expenseCategories: ExpenseCategory[];
}

export interface ExpenseCategory {
    id:          number;
    category:    string;
    description: string;
}

export interface GetExpensesResponse {
    expenses: Expense[];
}

export interface Expense {
    id:          number;
    apartmentId: number;
    categoryId:  number;
    date:        Date;
    amount:      number;
    notes:       string;
}

export interface GetGroupedByExpensesGroupResponse {
    expenses: GroupedGroupExpense[];
}

export interface GroupedGroupExpense {
    groupId:    number;
    categoryId: number;
    amount:     number;
}

export interface GetGroupedByExpensesResponse {
    expenses: GroupedExpense[];
}

export interface GroupedExpense {
    apartmentId: number;
    categoryId:  number;
    amount:      number;
}

export interface GetHostHubMappingStatusResponse {
    unmappedApartments: HostHubUnmappedApartment[];
    unmatchedRentals:   UnmatchedRentalElement[];
}

export interface HostHubUnmappedApartment {
    id:   number;
    name: string;
}

export interface UnmatchedRentalElement {
    id:   string;
    name: string;
}

export interface GetHostHubRentalsResponse {
    rentals: RentalElement[];
}

export interface RentalElement {
    id:   string;
    name: string;
}

export interface GetHostHubSyncIssuesResponse {
    hasRun:     boolean;
    issues:     HostHubSyncIssue[];
    lastRunAt?: Date;
}

export interface HostHubSyncIssue {
    apartmentId:     number;
    apartmentName:   string;
    bookingRef:      string;
    eventType:       string;
    firstObservedAt: Date;
    reason:          string;
    rentalId:        string;
    waitingCount:    number;
}

export interface GetManagementFeeRatioResponse {
    managementFeeRatio: ManagementFeeRatioClass;
}

export interface ManagementFeeRatioClass {
    id:                 number;
    apartmentId:        number;
    managementFeeRatio: number;
    fromDate:           Date;
}

export interface GetManagementFeeRatiosResponse {
    managementFeeRatios: ManagementFeeRatio[];
}

export interface ManagementFeeRatio {
    id:                 number;
    apartmentId:        number;
    managementFeeRatio: number;
    fromDate:           Date;
}

export interface GetMonthlyApartmentStatsResponse {
    apartmentStats:     ApartmentStats[];
    months:             Date[];
    numberOfApartments: number;
}

export interface ApartmentStats {
    apartmentId:                   number;
    availableBookingDays:          number;
    averageBlt:                    number;
    averageLengthOfStay:           number;
    businessFee:                   number;
    cleaningFees:                  number;
    daysBlocked:                   number;
    daysBooked:                    number;
    daysBookedForStartingInPeriod: number;
    grossAdr:                      number;
    grossIncome:                   number;
    grossIncomeAdjusted:           number;
    leadDays?:                     number;
    netAdr:                        number;
    netIncome:                     number;
    netIncomeAdjusted:             number;
    numberOfReservationsReceived:  number;
    numberOfVisits:                number;
    occupancy:                     number;
    platformCommissions:           number;
    sustainabilityFee:             number;
    temporaryStayDuty:             number;
    vat:                           number;
}

export interface GetMunicipalitySectionsResponse {
    municipalitySections: MunicipalitySection[];
}

export interface MunicipalitySection {
    id:   number;
    name: string;
}

export interface GetMunicipalitySectionsWithCountsResponse {
    municipalitySections: MunicipalitySectionElement[];
}

export interface MunicipalitySectionElement {
    activeApartmentCount: number;
    id:                   number;
    name:                 string;
}

export interface GetNeedsRefileResponse {
    reservations: NeedsRefileItem[];
}

export interface NeedsRefileItem {
    apartmentId:                 number;
    apartmentName:               string;
    endDate:                     Date;
    isUploadedToMyData:          boolean;
    reason:                      string;
    reservationCode:             string;
    reservationId:               number;
    startDate:                   Date;
    uploadedToShortTermRegistry: boolean;
}

export interface GetNeteraAccountsResponse {
    accounts: AccountElement[];
}

export interface AccountElement {
    apiKeySet:         boolean;
    id:                number;
    passwordChangedAt: Date;
    targets:           AccountTarget[];
    username:          string;
}

export interface AccountTarget {
    apartmentCount: number;
    branchId:       string;
    hotelId:        string;
    id:             number;
    label:          string;
}

export interface GetNeteraCredentialLabelsResponse {
    labels: NeteraCredentialLabel[];
}

export interface NeteraCredentialLabel {
    id:    number;
    label: string;
}

export interface GetOccupanciesResponse {
    date:        Date;
    occupancies: OccupancyItem[];
}

export interface OccupancyItem {
    date:          Date;
    daysBooked:    number;
    daysAvailable: number;
    occupancy:     number;
}

export interface GetOverviewStatsResponse {
    overviewStats: OverviewStats;
    [property: string]: any;
}

export interface OverviewStats {
    groupStats: GroupStat[];
    totalStats: TotalStatsClass;
    [property: string]: any;
}

export interface GroupStat {
    apartmentsInGroup:               number;
    apartmentsInGroupPrevious:       number;
    apartmentsInGroupPreviousYear:   number;
    averageLengthOfStay:             number;
    averageLengthOfStayPrevious:     number;
    averageLengthOfStayPreviousYear: number;
    blt:                             number;
    bltPrevious:                     number;
    bltPreviousYear:                 number;
    bookingsReceived:                number;
    bookingsReceivedPrevious:        number;
    bookingsReceivedPreviousYear:    number;
    daysBooked:                      number;
    daysBookedPrevious:              number;
    daysBookedPreviousYear:          number;
    grossAdr:                        number;
    grossAdrPrevious:                number;
    grossAdrPreviousYear:            number;
    grossIncome:                     number;
    grossIncomePrevious:             number;
    grossIncomePreviousYear:         number;
    groupId:                         number;
    netAdr:                          number;
    netAdrPrevious:                  number;
    netAdrPreviousYear:              number;
    netIncome:                       number;
    netIncomePrevious:               number;
    netIncomePreviousYear:           number;
    occupancy:                       number;
    occupancyPrevious:               number;
    occupancyPreviousYear:           number;
    [property: string]: any;
}

export interface TotalStatsClass {
    availableBookingDays:          number;
    averageBlt:                    number;
    averageLengthOfStay:           number;
    businessFee:                   number;
    cleaningFees:                  number;
    daysBlocked:                   number;
    daysBooked:                    number;
    daysBookedForStartingInPeriod: number;
    grossAdr:                      number;
    grossIncome:                   number;
    grossIncomeAdjusted:           number;
    leadDays?:                     number;
    netAdr:                        number;
    netIncome:                     number;
    netIncomeAdjusted:             number;
    numberOfReservationsReceived:  number;
    numberOfVisits:                number;
    occupancy:                     number;
    platformCommissions:           number;
    sustainabilityFee:             number;
    temporaryStayDuty:             number;
    vat:                           number;
}

export interface GetOwnerAirbnbReviewsResponse {
    reviews: OwnerAirbnbReview[];
}

export interface OwnerAirbnbReview {
    apartmentId:     number;
    date:            Date;
    numberOfReviews: number;
    overallScore:    number;
}

export interface GetOwnerGroupsResponse {
    ownerGroups: OwnerGroup[];
}

export interface OwnerGroup {
    id:         number;
    monthlyFee: number;
    name:       string;
}

export interface GetOwnerGroupsWithCountsResponse {
    ownerGroups: OwnerGroupElement[];
}

export interface OwnerGroupElement {
    activeApartmentCount: number;
    id:                   number;
    monthlyFee:           number;
    name:                 string;
}

export interface GetPayoutRatioResponse {
    payoutRatio: PayoutRatioClass;
}

export interface PayoutRatioClass {
    id:          number;
    apartmentId: number;
    payoutRatio: number;
    fromDate:    Date;
}

export interface GetPayoutRatiosResponse {
    payoutRatios: PayoutRatio[];
}

export interface PayoutRatio {
    id:          number;
    apartmentId: number;
    payoutRatio: number;
    fromDate:    Date;
}

export interface GetPayoutsReponse {
    payoutStats: PayoutStat[];
}

export interface PayoutStat {
    apartmentId:       number;
    cumulativeDeposit: number;
    deposit:           number;
    expenses:          number;
    fromDate:          Date;
    grossIncome:       number;
    managementFee:     number;
    netIncome:         number;
    payout:            number;
    payoutRatio:       number;
    toDate:            Date;
    [property: string]: any;
}

export interface GetPayoutStatsResponse {
    payoutStats: PayoutStat[];
}

export interface GetPeriodBreakdownStatsResponse {
    periodBreakdownStats: PeriodBreakdownStats;
    [property: string]: any;
}

export interface PeriodBreakdownStats {
    apartmentStats: Array<ApartmentStats[]>;
    periodNames:    string[];
    [property: string]: any;
}

export interface GetReservationDigestResponse {
    days:          DigestDay[];
    lastSyncedAt?: Date;
    rangeTotals:   DigestTotals;
}

export interface DigestDay {
    blocks:        DigestBlocks;
    cancellations: DigestItem[];
    date:          Date;
    modifications: DigestItem[];
    newBookings:   DigestItem[];
    totals:        DigestTotals;
}

export interface DigestBlocks {
    added:             DigestBlockItem[];
    housekeepingCount: number;
    removed:           DigestBlockItem[];
}

export interface DigestBlockItem {
    apartmentId:   number;
    apartmentName: string;
    blockId:       number;
    endDate:       Date;
    hasConflict:   boolean;
    nights:        number;
    origin:        string;
    reason:        string;
    startDate:     Date;
    status:        string;
    title:         string;
    versionId:     number;
}

export interface DigestItem {
    adr?:             number;
    apartmentId:      number;
    apartmentName:    string;
    bookedOn:         Date;
    cancelledAt?:     Date;
    changes?:         DigestChange[];
    checkIn:          Date;
    checkOut:         Date;
    guestName:        string;
    netIncome:        number;
    nights:           number;
    platform:         number;
    receivableIncome: number;
    reservationCode:  string;
    reservationId:    number;
    status:           string;
    versionId:        number;
}

export interface DigestChange {
    field: string;
    from:  string;
    to:    string;
}

export interface DigestTotals {
    blocksCount:        number;
    cancellationsCount: number;
    cancelledNights?:   number;
    modificationsCount: number;
    newBookingsCount:   number;
    nights:             number;
    revenue:            number;
}

export interface GetReservationHistoryResponse {
    history: ReservationVersion[];
}

export interface ReservationVersion {
    actualDaysOfStay:            number;
    amountPaid?:                 number;
    apartmentId:                 number;
    bookingDate:                 Date;
    cancelledAt?:                Date;
    changeReason?:               string;
    changeSource:                string;
    cleanerId?:                  number;
    cleaningCost?:               number;
    cleaningFee?:                number;
    cleaningOverridden:          boolean;
    commission:                  number;
    endDate:                     Date;
    epsilon:                     boolean;
    grossAdr:                    number;
    guestId?:                    string;
    guestName:                   string;
    hosthubEventUpdated?:        number;
    hostingExpense?:             number;
    id:                          number;
    isCancelled?:                boolean;
    isSyncFrozen?:               boolean;
    isTaxExempt:                 boolean;
    managementFee:               number;
    needsRefile?:                boolean;
    netAdr:                      number;
    netIncome:                   number;
    numberOfGuests:              number;
    origin?:                     string;
    paymentDate?:                Date;
    payout:                      number;
    platform:                    number;
    receivableIncome:            number;
    reservationCode:             string;
    startDate:                   Date;
    sustainabilityFee:           number;
    temporaryStayDuty:           number;
    uploadedToShortTermRegistry: boolean;
    vat:                         number;
    versionCreatedAt:            Date;
    versionId:                   number;
}

export interface GetReservationsResponse {
    reservations: ReservationElement[];
}

export interface ReservationElement {
    actualDaysOfStay:            number;
    amountPaid?:                 number;
    apartmentId:                 number;
    bookingDate:                 Date;
    cancelledAt?:                Date;
    changeReason?:               string;
    cleanerId?:                  number;
    cleaningCost?:               number;
    cleaningFee?:                number;
    cleaningOverridden:          boolean;
    commission:                  number;
    endDate:                     Date;
    epsilon:                     boolean;
    grossAdr:                    number;
    guestId?:                    string;
    guestName:                   string;
    hostingExpense?:             number;
    id:                          number;
    isCancelled?:                boolean;
    isSyncFrozen?:               boolean;
    isTaxExempt:                 boolean;
    managementFee:               number;
    needsRefile?:                boolean;
    netAdr:                      number;
    netIncome:                   number;
    numberOfGuests:              number;
    origin?:                     string;
    paymentDate?:                Date;
    payout:                      number;
    platform:                    number;
    receivableIncome:            number;
    reservationCode:             string;
    startDate:                   Date;
    sustainabilityFee:           number;
    temporaryStayDuty:           number;
    uploadedToShortTermRegistry: boolean;
    vat:                         number;
}

export interface GetReviewPerformanceResponse {
    periodLabel:        string;
    rows:               ReviewPerformanceRow[];
    showPreviousPeriod: boolean;
    showPreviousYear:   boolean;
}

export interface ReviewPerformanceRow {
    accuracy:         ReviewPerformanceCell;
    apartmentId:      number;
    apartmentName:    string;
    baselineDate:     null | string;
    checkIn:          ReviewPerformanceCell;
    cleanliness:      ReviewPerformanceCell;
    communication:    ReviewPerformanceCell;
    location:         ReviewPerformanceCell;
    newReviews:       number | null;
    newReviewsReason: null | string;
    observedDate:     null | string;
    overall:          ReviewPerformanceCell;
    rowStatus:        string;
    totalReviews:     number | null;
    value:            ReviewPerformanceCell;
}

export interface ReviewPerformanceCell {
    cohort:                  number | null;
    cohortReason:            null | string;
    driftVsPrevPeriod:       number | null;
    driftVsPrevPeriodReason: null | string;
    driftVsPrevYear:         number | null;
    driftVsPrevYearReason:   null | string;
    lifetime:                number | null;
}

export interface GetSavedGridViewsResponse {
    views: GridView[];
}

/**
 * Response for uploading a record to the short-term registry
 */
export interface GetShortTermRegistryRecordsResponse {
    strUploadResults: StrUploadResult[];
    /**
     * The ID of the task that was created to upload the records
     */
    taskId: number;
    [property: string]: any;
}

export interface StrUploadResult {
    reservationCode: string;
    status:          StrUploadResultStatus;
    text:            string;
    [property: string]: any;
}

export enum StrUploadResultStatus {
    Error = "error",
    Pending = "pending",
    Success = "success",
}

export interface GetStatsForApartmentsResponse {
    apartmentStats: ApartmentStats[];
}

export interface GetStatsForApartmentsWithDates {
    apartmentStats: ApartmentStats[];
}

export interface GetStatsForGroupsResponse {
    fromDate:   Date;
    groupStats: GroupStats[];
    toDate:     Date;
}

export interface GroupStats {
    availableBookingDays:          number;
    averageBlt:                    number;
    averageLengthOfStay:           number;
    businessFee:                   number;
    cleaningFees:                  number;
    daysBlocked:                   number;
    daysBooked:                    number;
    daysBookedForStartingInPeriod: number;
    grossAdr:                      number;
    grossIncome:                   number;
    grossIncomeAdjusted:           number;
    groupId:                       number;
    leadDays?:                     number;
    netAdr:                        number;
    netIncome:                     number;
    netIncomeAdjusted:             number;
    numberOfApartments:            number;
    numberOfReservationsReceived:  number;
    numberOfVisits:                number;
    occupancy:                     number;
    platformCommissions:           number;
    sustainabilityFee:             number;
    temporaryStayDuty:             number;
    vat:                           number;
}

export interface GetStrOwnersResponse {
    defaultOwnerId: number;
    owners:         StrOwnerLabel[];
}

export interface StrOwnerLabel {
    id:            number;
    name:          string;
    taxisUsername: string;
}

export interface GetTagsWithCountsResponse {
    tags: TagElement[];
}

export interface TagElement {
    activeApartmentCount: number;
    id:                   number;
    name:                 string;
}

export interface GetTotalStatsResponse {
    fromDate:           Date;
    numberOfApartments: number;
    toDate:             Date;
    totalStats:         TotalStats;
}

export interface TotalStats {
    availableBookingDays:          number;
    averageBlt:                    number;
    averageLengthOfStay:           number;
    businessFee:                   number;
    cleaningFees:                  number;
    daysBlocked:                   number;
    daysBooked:                    number;
    daysBookedForStartingInPeriod: number;
    grossAdr:                      number;
    grossIncome:                   number;
    grossIncomeAdjusted:           number;
    leadDays?:                     number;
    netAdr:                        number;
    netIncome:                     number;
    netIncomeAdjusted:             number;
    numberOfReservationsReceived:  number;
    numberOfVisits:                number;
    occupancy:                     number;
    platformCommissions:           number;
    sustainabilityFee:             number;
    temporaryStayDuty:             number;
    vat:                           number;
}

export interface GetUserResponse {
    user: User;
    [property: string]: any;
}

export interface GetYearsInOperationResponse {
    years: number[];
}

export interface ImportExpensesResponse {
    importExpensesResult: ImportExpensesResult;
    [property: string]: any;
}

export interface ImportExpensesResult {
    DeletedExpenseItems: number;
    newExpenseItems:     number;
    [property: string]: any;
}

export interface MunicipalitySectionInUseError {
    errors: MunicipalitySectionInUseErrorEntry[];
}

export interface MunicipalitySectionInUseErrorEntry {
    blockingApartments: PurpleBlockingApartmentEntry[];
    message:            string;
}

export interface PurpleBlockingApartmentEntry {
    apartmentId:   number;
    apartmentName: string;
}

export interface MunicipalitySectionWithCount {
    activeApartmentCount: number;
    id:                   number;
    name:                 string;
}

export interface NeteraAccount {
    apiKeySet:         boolean;
    id:                number;
    passwordChangedAt: Date;
    targets:           NeteraAccountTarget[];
    username:          string;
}

export interface NeteraAccountTarget {
    apartmentCount: number;
    branchId:       string;
    hotelId:        string;
    id:             number;
    label:          string;
}

export interface OwnerGroupInUseError {
    errors: OwnerGroupInUseErrorEntry[];
}

export interface OwnerGroupInUseErrorEntry {
    blockingApartments: FluffyBlockingApartmentEntry[];
    message:            string;
}

export interface FluffyBlockingApartmentEntry {
    apartmentId:   number;
    apartmentName: string;
}

export interface OwnerGroupWithCount {
    activeApartmentCount: number;
    id:                   number;
    monthlyFee:           number;
    name:                 string;
}

export interface ReconciliationResponse {
    result: ReconciliationResult;
}

export interface ReconciliationResult {
    cancelledOnly:    CancelledOnlyElement[];
    excelOnly:        ExcelReservationRow[];
    hosthubOnly:      CancelledOnlyElement[];
    matchedDiffering: MatchedDifference[];
    matchedEqual:     MatchedPair[];
}

export interface CancelledOnlyElement {
    actualDaysOfStay:            number;
    amountPaid?:                 number;
    apartmentId:                 number;
    bookingDate:                 Date;
    cancelledAt?:                Date;
    changeReason?:               string;
    cleanerId?:                  number;
    cleaningCost?:               number;
    cleaningFee?:                number;
    cleaningOverridden:          boolean;
    commission:                  number;
    endDate:                     Date;
    epsilon:                     boolean;
    grossAdr:                    number;
    guestId?:                    string;
    guestName:                   string;
    hostingExpense?:             number;
    id:                          number;
    isCancelled?:                boolean;
    isSyncFrozen?:               boolean;
    isTaxExempt:                 boolean;
    managementFee:               number;
    needsRefile?:                boolean;
    netAdr:                      number;
    netIncome:                   number;
    numberOfGuests:              number;
    origin?:                     string;
    paymentDate?:                Date;
    payout:                      number;
    platform:                    number;
    receivableIncome:            number;
    reservationCode:             string;
    startDate:                   Date;
    sustainabilityFee:           number;
    temporaryStayDuty:           number;
    uploadedToShortTermRegistry: boolean;
    vat:                         number;
}

export interface ExcelReservationRow {
    apartmentId:      number;
    endDate:          Date;
    guestName:        string;
    nights:           number;
    platform:         number;
    receivableIncome: number;
    reservationCode:  string;
    startDate:        Date;
}

export interface MatchedDifference {
    differences: FieldDifference[];
    excel:       ExcelReservationRow;
    hosthub:     CancelledOnlyElement;
}

export interface FieldDifference {
    excelValue:   string;
    field:        string;
    hosthubValue: string;
}

export interface MatchedPair {
    excel:   ExcelReservationRow;
    hosthub: CancelledOnlyElement;
}

export interface Tag {
    id:   number;
    name: string;
}

export interface TagInUseError {
    errors: TagInUseErrorEntry[];
}

export interface TagInUseErrorEntry {
    blockingApartments: TentacledBlockingApartmentEntry[];
    message:            string;
}

export interface TentacledBlockingApartmentEntry {
    apartmentId:   number;
    apartmentName: string;
}

export interface TagWithCount {
    activeApartmentCount: number;
    id:                   number;
    name:                 string;
}

export interface UploadToMyDataResponse {
    myDataUploadResponse: MyDataUploadResponse[];
}

export interface MyDataUploadResponse {
    error:           string;
    invoiceUUID:     string;
    reservationCode: string;
    status:          MyDataUploadResponseStatus;
    taxInvoiceUUID:  string;
}

export enum MyDataUploadResponseStatus {
    AlreadyFiled = "already-filed",
    Failed = "failed",
    Filed = "filed",
    NeedsReconciliation = "needs-reconciliation",
}

/**
 * Response for uploading a record to the short-term registry
 */
export interface UploadToShortTermRegistryResponse {
    /**
     * The ID of the task that was created to upload the records
     */
    taskId: number;
    [property: string]: any;
}

export interface UpsertDashboardLayoutResponse {
    layout: DashboardLayout;
}

export interface AddMunicipalitySectionRequest {
    name: string;
}

export interface AddOwnerGroupRequest {
    monthlyFee: number;
    name:       string;
}

export interface AddTagRequest {
    name: string;
}

export interface CreateNeteraAccountRequest {
    apiKey:   string;
    password: string;
    targets:  NewNeteraTarget[];
    username: string;
}

export interface NewNeteraTarget {
    branchId: string;
    hotelId:  string;
    label:    string;
}

export interface UpdateMunicipalitySectionRequest {
    name: string;
}

export interface UpdateOwnerGroupRequest {
    monthlyFee: number;
    name:       string;
}

export interface UpdateTagRequest {
    name: string;
}

export interface UpsertDashboardLayoutRequest {
    id?:         number;
    dashboardId: string;
    layoutName:  string;
    layout:      { [key: string]: any };
}

// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
export class Convert {
    public static toAddApartmentBlockRequest(json: string): AddApartmentBlockRequest {
        return cast(JSON.parse(json), r("AddApartmentBlockRequest"));
    }

    public static addApartmentBlockRequestToJson(value: AddApartmentBlockRequest): string {
        return JSON.stringify(uncast(value, r("AddApartmentBlockRequest")), null, 2);
    }

    public static toAddress(json: string): Address {
        return cast(JSON.parse(json), r("Address"));
    }

    public static addressToJson(value: Address): string {
        return JSON.stringify(uncast(value, r("Address")), null, 2);
    }

    public static toAddSavedGridViewRequest(json: string): AddSavedGridViewRequest {
        return cast(JSON.parse(json), r("AddSavedGridViewRequest"));
    }

    public static addSavedGridViewRequestToJson(value: AddSavedGridViewRequest): string {
        return JSON.stringify(uncast(value, r("AddSavedGridViewRequest")), null, 2);
    }

    public static toAddSavedGridViewResponse(json: string): AddSavedGridViewResponse {
        return cast(JSON.parse(json), r("AddSavedGridViewResponse"));
    }

    public static addSavedGridViewResponseToJson(value: AddSavedGridViewResponse): string {
        return JSON.stringify(uncast(value, r("AddSavedGridViewResponse")), null, 2);
    }

    public static toAddTagResponse(json: string): AddTagResponse {
        return cast(JSON.parse(json), r("AddTagResponse"));
    }

    public static addTagResponseToJson(value: AddTagResponse): string {
        return JSON.stringify(uncast(value, r("AddTagResponse")), null, 2);
    }

    public static toApartment(json: string): Apartment {
        return cast(JSON.parse(json), r("Apartment"));
    }

    public static apartmentToJson(value: Apartment): string {
        return JSON.stringify(uncast(value, r("Apartment")), null, 2);
    }

    public static toApartmentOwner(json: string): ApartmentOwner {
        return cast(JSON.parse(json), r("ApartmentOwner"));
    }

    public static apartmentOwnerToJson(value: ApartmentOwner): string {
        return JSON.stringify(uncast(value, r("ApartmentOwner")), null, 2);
    }

    public static toApartmentStats(json: string): ApartmentStats {
        return cast(JSON.parse(json), r("ApartmentStats"));
    }

    public static apartmentStatsToJson(value: ApartmentStats): string {
        return JSON.stringify(uncast(value, r("ApartmentStats")), null, 2);
    }

    public static toDashboardLayout(json: string): DashboardLayout {
        return cast(JSON.parse(json), r("DashboardLayout"));
    }

    public static dashboardLayoutToJson(value: DashboardLayout): string {
        return JSON.stringify(uncast(value, r("DashboardLayout")), null, 2);
    }

    public static toGetAddressesResponse(json: string): GetAddressesResponse {
        return cast(JSON.parse(json), r("GetAddressesResponse"));
    }

    public static getAddressesResponseToJson(value: GetAddressesResponse): string {
        return JSON.stringify(uncast(value, r("GetAddressesResponse")), null, 2);
    }

    public static toGetAddressesWithCountsResponse(json: string): GetAddressesWithCountsResponse {
        return cast(JSON.parse(json), r("GetAddressesWithCountsResponse"));
    }

    public static getAddressesWithCountsResponseToJson(value: GetAddressesWithCountsResponse): string {
        return JSON.stringify(uncast(value, r("GetAddressesWithCountsResponse")), null, 2);
    }

    public static toGetAirbnbReviewsResponse(json: string): GetAirbnbReviewsResponse {
        return cast(JSON.parse(json), r("GetAirbnbReviewsResponse"));
    }

    public static getAirbnbReviewsResponseToJson(value: GetAirbnbReviewsResponse): string {
        return JSON.stringify(uncast(value, r("GetAirbnbReviewsResponse")), null, 2);
    }

    public static toGetAllTagsResponse(json: string): GetAllTagsResponse {
        return cast(JSON.parse(json), r("GetAllTagsResponse"));
    }

    public static getAllTagsResponseToJson(value: GetAllTagsResponse): string {
        return JSON.stringify(uncast(value, r("GetAllTagsResponse")), null, 2);
    }

    public static toGetAllUsersResponse(json: string): GetAllUsersResponse {
        return cast(JSON.parse(json), r("GetAllUsersResponse"));
    }

    public static getAllUsersResponseToJson(value: GetAllUsersResponse): string {
        return JSON.stringify(uncast(value, r("GetAllUsersResponse")), null, 2);
    }

    public static toGetApartmentBlocks(json: string): GetApartmentBlocks {
        return cast(JSON.parse(json), r("GetApartmentBlocks"));
    }

    public static getApartmentBlocksToJson(value: GetApartmentBlocks): string {
        return JSON.stringify(uncast(value, r("GetApartmentBlocks")), null, 2);
    }

    public static toGetApartmentGroupsResponse(json: string): GetApartmentGroupsResponse {
        return cast(JSON.parse(json), r("GetApartmentGroupsResponse"));
    }

    public static getApartmentGroupsResponseToJson(value: GetApartmentGroupsResponse): string {
        return JSON.stringify(uncast(value, r("GetApartmentGroupsResponse")), null, 2);
    }

    public static toGetApartmentOwnerResponse(json: string): GetApartmentOwnerResponse {
        return cast(JSON.parse(json), r("GetApartmentOwnerResponse"));
    }

    public static getApartmentOwnerResponseToJson(value: GetApartmentOwnerResponse): string {
        return JSON.stringify(uncast(value, r("GetApartmentOwnerResponse")), null, 2);
    }

    public static toGetApartmentOwnersResponse(json: string): GetApartmentOwnersResponse {
        return cast(JSON.parse(json), r("GetApartmentOwnersResponse"));
    }

    public static getApartmentOwnersResponseToJson(value: GetApartmentOwnersResponse): string {
        return JSON.stringify(uncast(value, r("GetApartmentOwnersResponse")), null, 2);
    }

    public static toGetApartmentResponse(json: string): GetApartmentResponse {
        return cast(JSON.parse(json), r("GetApartmentResponse"));
    }

    public static getApartmentResponseToJson(value: GetApartmentResponse): string {
        return JSON.stringify(uncast(value, r("GetApartmentResponse")), null, 2);
    }

    public static toGetApartmentsResponse(json: string): GetApartmentsResponse {
        return cast(JSON.parse(json), r("GetApartmentsResponse"));
    }

    public static getApartmentsResponseToJson(value: GetApartmentsResponse): string {
        return JSON.stringify(uncast(value, r("GetApartmentsResponse")), null, 2);
    }

    public static toGetApartmentStatTrends(json: string): GetApartmentStatTrends {
        return cast(JSON.parse(json), r("GetApartmentStatTrends"));
    }

    public static getApartmentStatTrendsToJson(value: GetApartmentStatTrends): string {
        return JSON.stringify(uncast(value, r("GetApartmentStatTrends")), null, 2);
    }

    public static toGetBltStatsResponse(json: string): GetBltStatsResponse {
        return cast(JSON.parse(json), r("GetBltStatsResponse"));
    }

    public static getBltStatsResponseToJson(value: GetBltStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetBltStatsResponse")), null, 2);
    }

    public static toGetBookingPaceResponse(json: string): GetBookingPaceResponse {
        return cast(JSON.parse(json), r("GetBookingPaceResponse"));
    }

    public static getBookingPaceResponseToJson(value: GetBookingPaceResponse): string {
        return JSON.stringify(uncast(value, r("GetBookingPaceResponse")), null, 2);
    }

    public static toGetDashboardLayoutsResponse(json: string): GetDashboardLayoutsResponse {
        return cast(JSON.parse(json), r("GetDashboardLayoutsResponse"));
    }

    public static getDashboardLayoutsResponseToJson(value: GetDashboardLayoutsResponse): string {
        return JSON.stringify(uncast(value, r("GetDashboardLayoutsResponse")), null, 2);
    }

    public static toGetExpenseCategoriesResponse(json: string): GetExpenseCategoriesResponse {
        return cast(JSON.parse(json), r("GetExpenseCategoriesResponse"));
    }

    public static getExpenseCategoriesResponseToJson(value: GetExpenseCategoriesResponse): string {
        return JSON.stringify(uncast(value, r("GetExpenseCategoriesResponse")), null, 2);
    }

    public static toGetExpensesResponse(json: string): GetExpensesResponse {
        return cast(JSON.parse(json), r("GetExpensesResponse"));
    }

    public static getExpensesResponseToJson(value: GetExpensesResponse): string {
        return JSON.stringify(uncast(value, r("GetExpensesResponse")), null, 2);
    }

    public static toGetGroupedByExpensesGroupResponse(json: string): GetGroupedByExpensesGroupResponse {
        return cast(JSON.parse(json), r("GetGroupedByExpensesGroupResponse"));
    }

    public static getGroupedByExpensesGroupResponseToJson(value: GetGroupedByExpensesGroupResponse): string {
        return JSON.stringify(uncast(value, r("GetGroupedByExpensesGroupResponse")), null, 2);
    }

    public static toGetGroupedByExpensesResponse(json: string): GetGroupedByExpensesResponse {
        return cast(JSON.parse(json), r("GetGroupedByExpensesResponse"));
    }

    public static getGroupedByExpensesResponseToJson(value: GetGroupedByExpensesResponse): string {
        return JSON.stringify(uncast(value, r("GetGroupedByExpensesResponse")), null, 2);
    }

    public static toGetHostHubMappingStatusResponse(json: string): GetHostHubMappingStatusResponse {
        return cast(JSON.parse(json), r("GetHostHubMappingStatusResponse"));
    }

    public static getHostHubMappingStatusResponseToJson(value: GetHostHubMappingStatusResponse): string {
        return JSON.stringify(uncast(value, r("GetHostHubMappingStatusResponse")), null, 2);
    }

    public static toGetHostHubRentalsResponse(json: string): GetHostHubRentalsResponse {
        return cast(JSON.parse(json), r("GetHostHubRentalsResponse"));
    }

    public static getHostHubRentalsResponseToJson(value: GetHostHubRentalsResponse): string {
        return JSON.stringify(uncast(value, r("GetHostHubRentalsResponse")), null, 2);
    }

    public static toGetHostHubSyncIssuesResponse(json: string): GetHostHubSyncIssuesResponse {
        return cast(JSON.parse(json), r("GetHostHubSyncIssuesResponse"));
    }

    public static getHostHubSyncIssuesResponseToJson(value: GetHostHubSyncIssuesResponse): string {
        return JSON.stringify(uncast(value, r("GetHostHubSyncIssuesResponse")), null, 2);
    }

    public static toGetManagementFeeRatioResponse(json: string): GetManagementFeeRatioResponse {
        return cast(JSON.parse(json), r("GetManagementFeeRatioResponse"));
    }

    public static getManagementFeeRatioResponseToJson(value: GetManagementFeeRatioResponse): string {
        return JSON.stringify(uncast(value, r("GetManagementFeeRatioResponse")), null, 2);
    }

    public static toGetManagementFeeRatiosResponse(json: string): GetManagementFeeRatiosResponse {
        return cast(JSON.parse(json), r("GetManagementFeeRatiosResponse"));
    }

    public static getManagementFeeRatiosResponseToJson(value: GetManagementFeeRatiosResponse): string {
        return JSON.stringify(uncast(value, r("GetManagementFeeRatiosResponse")), null, 2);
    }

    public static toGetMonthlyApartmentStatsResponse(json: string): GetMonthlyApartmentStatsResponse {
        return cast(JSON.parse(json), r("GetMonthlyApartmentStatsResponse"));
    }

    public static getMonthlyApartmentStatsResponseToJson(value: GetMonthlyApartmentStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetMonthlyApartmentStatsResponse")), null, 2);
    }

    public static toGetMunicipalitySectionsResponse(json: string): GetMunicipalitySectionsResponse {
        return cast(JSON.parse(json), r("GetMunicipalitySectionsResponse"));
    }

    public static getMunicipalitySectionsResponseToJson(value: GetMunicipalitySectionsResponse): string {
        return JSON.stringify(uncast(value, r("GetMunicipalitySectionsResponse")), null, 2);
    }

    public static toGetMunicipalitySectionsWithCountsResponse(json: string): GetMunicipalitySectionsWithCountsResponse {
        return cast(JSON.parse(json), r("GetMunicipalitySectionsWithCountsResponse"));
    }

    public static getMunicipalitySectionsWithCountsResponseToJson(value: GetMunicipalitySectionsWithCountsResponse): string {
        return JSON.stringify(uncast(value, r("GetMunicipalitySectionsWithCountsResponse")), null, 2);
    }

    public static toGetNeedsRefileResponse(json: string): GetNeedsRefileResponse {
        return cast(JSON.parse(json), r("GetNeedsRefileResponse"));
    }

    public static getNeedsRefileResponseToJson(value: GetNeedsRefileResponse): string {
        return JSON.stringify(uncast(value, r("GetNeedsRefileResponse")), null, 2);
    }

    public static toGetNeteraAccountsResponse(json: string): GetNeteraAccountsResponse {
        return cast(JSON.parse(json), r("GetNeteraAccountsResponse"));
    }

    public static getNeteraAccountsResponseToJson(value: GetNeteraAccountsResponse): string {
        return JSON.stringify(uncast(value, r("GetNeteraAccountsResponse")), null, 2);
    }

    public static toGetNeteraCredentialLabelsResponse(json: string): GetNeteraCredentialLabelsResponse {
        return cast(JSON.parse(json), r("GetNeteraCredentialLabelsResponse"));
    }

    public static getNeteraCredentialLabelsResponseToJson(value: GetNeteraCredentialLabelsResponse): string {
        return JSON.stringify(uncast(value, r("GetNeteraCredentialLabelsResponse")), null, 2);
    }

    public static toGetOccupanciesResponse(json: string): GetOccupanciesResponse {
        return cast(JSON.parse(json), r("GetOccupanciesResponse"));
    }

    public static getOccupanciesResponseToJson(value: GetOccupanciesResponse): string {
        return JSON.stringify(uncast(value, r("GetOccupanciesResponse")), null, 2);
    }

    public static toGetOverviewStatsResponse(json: string): GetOverviewStatsResponse {
        return cast(JSON.parse(json), r("GetOverviewStatsResponse"));
    }

    public static getOverviewStatsResponseToJson(value: GetOverviewStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetOverviewStatsResponse")), null, 2);
    }

    public static toGetOwnerAirbnbReviewsResponse(json: string): GetOwnerAirbnbReviewsResponse {
        return cast(JSON.parse(json), r("GetOwnerAirbnbReviewsResponse"));
    }

    public static getOwnerAirbnbReviewsResponseToJson(value: GetOwnerAirbnbReviewsResponse): string {
        return JSON.stringify(uncast(value, r("GetOwnerAirbnbReviewsResponse")), null, 2);
    }

    public static toGetOwnerGroupsResponse(json: string): GetOwnerGroupsResponse {
        return cast(JSON.parse(json), r("GetOwnerGroupsResponse"));
    }

    public static getOwnerGroupsResponseToJson(value: GetOwnerGroupsResponse): string {
        return JSON.stringify(uncast(value, r("GetOwnerGroupsResponse")), null, 2);
    }

    public static toGetOwnerGroupsWithCountsResponse(json: string): GetOwnerGroupsWithCountsResponse {
        return cast(JSON.parse(json), r("GetOwnerGroupsWithCountsResponse"));
    }

    public static getOwnerGroupsWithCountsResponseToJson(value: GetOwnerGroupsWithCountsResponse): string {
        return JSON.stringify(uncast(value, r("GetOwnerGroupsWithCountsResponse")), null, 2);
    }

    public static toGetPayoutRatioResponse(json: string): GetPayoutRatioResponse {
        return cast(JSON.parse(json), r("GetPayoutRatioResponse"));
    }

    public static getPayoutRatioResponseToJson(value: GetPayoutRatioResponse): string {
        return JSON.stringify(uncast(value, r("GetPayoutRatioResponse")), null, 2);
    }

    public static toGetPayoutRatiosResponse(json: string): GetPayoutRatiosResponse {
        return cast(JSON.parse(json), r("GetPayoutRatiosResponse"));
    }

    public static getPayoutRatiosResponseToJson(value: GetPayoutRatiosResponse): string {
        return JSON.stringify(uncast(value, r("GetPayoutRatiosResponse")), null, 2);
    }

    public static toGetPayoutsReponse(json: string): GetPayoutsReponse {
        return cast(JSON.parse(json), r("GetPayoutsReponse"));
    }

    public static getPayoutsReponseToJson(value: GetPayoutsReponse): string {
        return JSON.stringify(uncast(value, r("GetPayoutsReponse")), null, 2);
    }

    public static toGetPayoutStatsResponse(json: string): GetPayoutStatsResponse {
        return cast(JSON.parse(json), r("GetPayoutStatsResponse"));
    }

    public static getPayoutStatsResponseToJson(value: GetPayoutStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetPayoutStatsResponse")), null, 2);
    }

    public static toGetPeriodBreakdownStatsResponse(json: string): GetPeriodBreakdownStatsResponse {
        return cast(JSON.parse(json), r("GetPeriodBreakdownStatsResponse"));
    }

    public static getPeriodBreakdownStatsResponseToJson(value: GetPeriodBreakdownStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetPeriodBreakdownStatsResponse")), null, 2);
    }

    public static toGetReservationDigestResponse(json: string): GetReservationDigestResponse {
        return cast(JSON.parse(json), r("GetReservationDigestResponse"));
    }

    public static getReservationDigestResponseToJson(value: GetReservationDigestResponse): string {
        return JSON.stringify(uncast(value, r("GetReservationDigestResponse")), null, 2);
    }

    public static toGetReservationHistoryResponse(json: string): GetReservationHistoryResponse {
        return cast(JSON.parse(json), r("GetReservationHistoryResponse"));
    }

    public static getReservationHistoryResponseToJson(value: GetReservationHistoryResponse): string {
        return JSON.stringify(uncast(value, r("GetReservationHistoryResponse")), null, 2);
    }

    public static toGetReservationsResponse(json: string): GetReservationsResponse {
        return cast(JSON.parse(json), r("GetReservationsResponse"));
    }

    public static getReservationsResponseToJson(value: GetReservationsResponse): string {
        return JSON.stringify(uncast(value, r("GetReservationsResponse")), null, 2);
    }

    public static toGetReviewPerformanceResponse(json: string): GetReviewPerformanceResponse {
        return cast(JSON.parse(json), r("GetReviewPerformanceResponse"));
    }

    public static getReviewPerformanceResponseToJson(value: GetReviewPerformanceResponse): string {
        return JSON.stringify(uncast(value, r("GetReviewPerformanceResponse")), null, 2);
    }

    public static toGetSavedGridViewsResponse(json: string): GetSavedGridViewsResponse {
        return cast(JSON.parse(json), r("GetSavedGridViewsResponse"));
    }

    public static getSavedGridViewsResponseToJson(value: GetSavedGridViewsResponse): string {
        return JSON.stringify(uncast(value, r("GetSavedGridViewsResponse")), null, 2);
    }

    public static toGetShortTermRegistryRecordsResponse(json: string): GetShortTermRegistryRecordsResponse {
        return cast(JSON.parse(json), r("GetShortTermRegistryRecordsResponse"));
    }

    public static getShortTermRegistryRecordsResponseToJson(value: GetShortTermRegistryRecordsResponse): string {
        return JSON.stringify(uncast(value, r("GetShortTermRegistryRecordsResponse")), null, 2);
    }

    public static toGetStatsForApartmentsResponse(json: string): GetStatsForApartmentsResponse {
        return cast(JSON.parse(json), r("GetStatsForApartmentsResponse"));
    }

    public static getStatsForApartmentsResponseToJson(value: GetStatsForApartmentsResponse): string {
        return JSON.stringify(uncast(value, r("GetStatsForApartmentsResponse")), null, 2);
    }

    public static toGetStatsForApartmentsWithDates(json: string): GetStatsForApartmentsWithDates {
        return cast(JSON.parse(json), r("GetStatsForApartmentsWithDates"));
    }

    public static getStatsForApartmentsWithDatesToJson(value: GetStatsForApartmentsWithDates): string {
        return JSON.stringify(uncast(value, r("GetStatsForApartmentsWithDates")), null, 2);
    }

    public static toGetStatsForGroupsResponse(json: string): GetStatsForGroupsResponse {
        return cast(JSON.parse(json), r("GetStatsForGroupsResponse"));
    }

    public static getStatsForGroupsResponseToJson(value: GetStatsForGroupsResponse): string {
        return JSON.stringify(uncast(value, r("GetStatsForGroupsResponse")), null, 2);
    }

    public static toGetStrOwnersResponse(json: string): GetStrOwnersResponse {
        return cast(JSON.parse(json), r("GetStrOwnersResponse"));
    }

    public static getStrOwnersResponseToJson(value: GetStrOwnersResponse): string {
        return JSON.stringify(uncast(value, r("GetStrOwnersResponse")), null, 2);
    }

    public static toGetTagsWithCountsResponse(json: string): GetTagsWithCountsResponse {
        return cast(JSON.parse(json), r("GetTagsWithCountsResponse"));
    }

    public static getTagsWithCountsResponseToJson(value: GetTagsWithCountsResponse): string {
        return JSON.stringify(uncast(value, r("GetTagsWithCountsResponse")), null, 2);
    }

    public static toGetTotalStatsResponse(json: string): GetTotalStatsResponse {
        return cast(JSON.parse(json), r("GetTotalStatsResponse"));
    }

    public static getTotalStatsResponseToJson(value: GetTotalStatsResponse): string {
        return JSON.stringify(uncast(value, r("GetTotalStatsResponse")), null, 2);
    }

    public static toGetUserResponse(json: string): GetUserResponse {
        return cast(JSON.parse(json), r("GetUserResponse"));
    }

    public static getUserResponseToJson(value: GetUserResponse): string {
        return JSON.stringify(uncast(value, r("GetUserResponse")), null, 2);
    }

    public static toGetYearsInOperationResponse(json: string): GetYearsInOperationResponse {
        return cast(JSON.parse(json), r("GetYearsInOperationResponse"));
    }

    public static getYearsInOperationResponseToJson(value: GetYearsInOperationResponse): string {
        return JSON.stringify(uncast(value, r("GetYearsInOperationResponse")), null, 2);
    }

    public static toGridView(json: string): GridView {
        return cast(JSON.parse(json), r("GridView"));
    }

    public static gridViewToJson(value: GridView): string {
        return JSON.stringify(uncast(value, r("GridView")), null, 2);
    }

    public static toGroupStats(json: string): GroupStats {
        return cast(JSON.parse(json), r("GroupStats"));
    }

    public static groupStatsToJson(value: GroupStats): string {
        return JSON.stringify(uncast(value, r("GroupStats")), null, 2);
    }

    public static toImportExpensesResponse(json: string): ImportExpensesResponse {
        return cast(JSON.parse(json), r("ImportExpensesResponse"));
    }

    public static importExpensesResponseToJson(value: ImportExpensesResponse): string {
        return JSON.stringify(uncast(value, r("ImportExpensesResponse")), null, 2);
    }

    public static toManagementFeeRatio(json: string): ManagementFeeRatio {
        return cast(JSON.parse(json), r("ManagementFeeRatio"));
    }

    public static managementFeeRatioToJson(value: ManagementFeeRatio): string {
        return JSON.stringify(uncast(value, r("ManagementFeeRatio")), null, 2);
    }

    public static toMunicipalitySection(json: string): MunicipalitySection {
        return cast(JSON.parse(json), r("MunicipalitySection"));
    }

    public static municipalitySectionToJson(value: MunicipalitySection): string {
        return JSON.stringify(uncast(value, r("MunicipalitySection")), null, 2);
    }

    public static toMunicipalitySectionInUseError(json: string): MunicipalitySectionInUseError {
        return cast(JSON.parse(json), r("MunicipalitySectionInUseError"));
    }

    public static municipalitySectionInUseErrorToJson(value: MunicipalitySectionInUseError): string {
        return JSON.stringify(uncast(value, r("MunicipalitySectionInUseError")), null, 2);
    }

    public static toMunicipalitySectionWithCount(json: string): MunicipalitySectionWithCount {
        return cast(JSON.parse(json), r("MunicipalitySectionWithCount"));
    }

    public static municipalitySectionWithCountToJson(value: MunicipalitySectionWithCount): string {
        return JSON.stringify(uncast(value, r("MunicipalitySectionWithCount")), null, 2);
    }

    public static toNeteraAccount(json: string): NeteraAccount {
        return cast(JSON.parse(json), r("NeteraAccount"));
    }

    public static neteraAccountToJson(value: NeteraAccount): string {
        return JSON.stringify(uncast(value, r("NeteraAccount")), null, 2);
    }

    public static toOwnerGroup(json: string): OwnerGroup {
        return cast(JSON.parse(json), r("OwnerGroup"));
    }

    public static ownerGroupToJson(value: OwnerGroup): string {
        return JSON.stringify(uncast(value, r("OwnerGroup")), null, 2);
    }

    public static toOwnerGroupInUseError(json: string): OwnerGroupInUseError {
        return cast(JSON.parse(json), r("OwnerGroupInUseError"));
    }

    public static ownerGroupInUseErrorToJson(value: OwnerGroupInUseError): string {
        return JSON.stringify(uncast(value, r("OwnerGroupInUseError")), null, 2);
    }

    public static toOwnerGroupWithCount(json: string): OwnerGroupWithCount {
        return cast(JSON.parse(json), r("OwnerGroupWithCount"));
    }

    public static ownerGroupWithCountToJson(value: OwnerGroupWithCount): string {
        return JSON.stringify(uncast(value, r("OwnerGroupWithCount")), null, 2);
    }

    public static toPayoutRatio(json: string): PayoutRatio {
        return cast(JSON.parse(json), r("PayoutRatio"));
    }

    public static payoutRatioToJson(value: PayoutRatio): string {
        return JSON.stringify(uncast(value, r("PayoutRatio")), null, 2);
    }

    public static toPayoutStat(json: string): PayoutStat {
        return cast(JSON.parse(json), r("PayoutStat"));
    }

    public static payoutStatToJson(value: PayoutStat): string {
        return JSON.stringify(uncast(value, r("PayoutStat")), null, 2);
    }

    public static toReconciliationResponse(json: string): ReconciliationResponse {
        return cast(JSON.parse(json), r("ReconciliationResponse"));
    }

    public static reconciliationResponseToJson(value: ReconciliationResponse): string {
        return JSON.stringify(uncast(value, r("ReconciliationResponse")), null, 2);
    }

    public static toTag(json: string): Tag {
        return cast(JSON.parse(json), r("Tag"));
    }

    public static tagToJson(value: Tag): string {
        return JSON.stringify(uncast(value, r("Tag")), null, 2);
    }

    public static toTagInUseError(json: string): TagInUseError {
        return cast(JSON.parse(json), r("TagInUseError"));
    }

    public static tagInUseErrorToJson(value: TagInUseError): string {
        return JSON.stringify(uncast(value, r("TagInUseError")), null, 2);
    }

    public static toTagWithCount(json: string): TagWithCount {
        return cast(JSON.parse(json), r("TagWithCount"));
    }

    public static tagWithCountToJson(value: TagWithCount): string {
        return JSON.stringify(uncast(value, r("TagWithCount")), null, 2);
    }

    public static toTotalStats(json: string): TotalStats {
        return cast(JSON.parse(json), r("TotalStats"));
    }

    public static totalStatsToJson(value: TotalStats): string {
        return JSON.stringify(uncast(value, r("TotalStats")), null, 2);
    }

    public static toUploadToMyDataResponse(json: string): UploadToMyDataResponse {
        return cast(JSON.parse(json), r("UploadToMyDataResponse"));
    }

    public static uploadToMyDataResponseToJson(value: UploadToMyDataResponse): string {
        return JSON.stringify(uncast(value, r("UploadToMyDataResponse")), null, 2);
    }

    public static toUploadToShortTermRegistryResponse(json: string): UploadToShortTermRegistryResponse {
        return cast(JSON.parse(json), r("UploadToShortTermRegistryResponse"));
    }

    public static uploadToShortTermRegistryResponseToJson(value: UploadToShortTermRegistryResponse): string {
        return JSON.stringify(uncast(value, r("UploadToShortTermRegistryResponse")), null, 2);
    }

    public static toUpsertDashboardLayoutResponse(json: string): UpsertDashboardLayoutResponse {
        return cast(JSON.parse(json), r("UpsertDashboardLayoutResponse"));
    }

    public static upsertDashboardLayoutResponseToJson(value: UpsertDashboardLayoutResponse): string {
        return JSON.stringify(uncast(value, r("UpsertDashboardLayoutResponse")), null, 2);
    }

    public static toUser(json: string): User {
        return cast(JSON.parse(json), r("User"));
    }

    public static userToJson(value: User): string {
        return JSON.stringify(uncast(value, r("User")), null, 2);
    }

    public static toAddMunicipalitySectionRequest(json: string): AddMunicipalitySectionRequest {
        return cast(JSON.parse(json), r("AddMunicipalitySectionRequest"));
    }

    public static addMunicipalitySectionRequestToJson(value: AddMunicipalitySectionRequest): string {
        return JSON.stringify(uncast(value, r("AddMunicipalitySectionRequest")), null, 2);
    }

    public static toAddOwnerGroupRequest(json: string): AddOwnerGroupRequest {
        return cast(JSON.parse(json), r("AddOwnerGroupRequest"));
    }

    public static addOwnerGroupRequestToJson(value: AddOwnerGroupRequest): string {
        return JSON.stringify(uncast(value, r("AddOwnerGroupRequest")), null, 2);
    }

    public static toAddTagRequest(json: string): AddTagRequest {
        return cast(JSON.parse(json), r("AddTagRequest"));
    }

    public static addTagRequestToJson(value: AddTagRequest): string {
        return JSON.stringify(uncast(value, r("AddTagRequest")), null, 2);
    }

    public static toCreateNeteraAccountRequest(json: string): CreateNeteraAccountRequest {
        return cast(JSON.parse(json), r("CreateNeteraAccountRequest"));
    }

    public static createNeteraAccountRequestToJson(value: CreateNeteraAccountRequest): string {
        return JSON.stringify(uncast(value, r("CreateNeteraAccountRequest")), null, 2);
    }

    public static toUpdateMunicipalitySectionRequest(json: string): UpdateMunicipalitySectionRequest {
        return cast(JSON.parse(json), r("UpdateMunicipalitySectionRequest"));
    }

    public static updateMunicipalitySectionRequestToJson(value: UpdateMunicipalitySectionRequest): string {
        return JSON.stringify(uncast(value, r("UpdateMunicipalitySectionRequest")), null, 2);
    }

    public static toUpdateOwnerGroupRequest(json: string): UpdateOwnerGroupRequest {
        return cast(JSON.parse(json), r("UpdateOwnerGroupRequest"));
    }

    public static updateOwnerGroupRequestToJson(value: UpdateOwnerGroupRequest): string {
        return JSON.stringify(uncast(value, r("UpdateOwnerGroupRequest")), null, 2);
    }

    public static toUpdateTagRequest(json: string): UpdateTagRequest {
        return cast(JSON.parse(json), r("UpdateTagRequest"));
    }

    public static updateTagRequestToJson(value: UpdateTagRequest): string {
        return JSON.stringify(uncast(value, r("UpdateTagRequest")), null, 2);
    }

    public static toUpsertDashboardLayoutRequest(json: string): UpsertDashboardLayoutRequest {
        return cast(JSON.parse(json), r("UpsertDashboardLayoutRequest"));
    }

    public static upsertDashboardLayoutRequestToJson(value: UpsertDashboardLayoutRequest): string {
        return JSON.stringify(uncast(value, r("UpsertDashboardLayoutRequest")), null, 2);
    }
}

function invalidValue(typ: any, val: any, key: any, parent: any = ''): never {
    const prettyTyp = prettyTypeName(typ);
    const parentText = parent ? ` on ${parent}` : '';
    const keyText = key ? ` for key "${key}"` : '';
    throw Error(`Invalid value${keyText}${parentText}. Expected ${prettyTyp} but got ${JSON.stringify(val)}`);
}

function prettyTypeName(typ: any): string {
    if (Array.isArray(typ)) {
        if (typ.length === 2 && typ[0] === undefined) {
            return `an optional ${prettyTypeName(typ[1])}`;
        } else {
            return `one of [${typ.map(a => { return prettyTypeName(a); }).join(", ")}]`;
        }
    } else if (typeof typ === "object" && typ.literal !== undefined) {
        return typ.literal;
    } else {
        return typeof typ;
    }
}

function jsonToJSProps(typ: any): any {
    if (typ.jsonToJS === undefined) {
        const map: any = {};
        typ.props.forEach((p: any) => map[p.json] = { key: p.js, typ: p.typ });
        typ.jsonToJS = map;
    }
    return typ.jsonToJS;
}

function jsToJSONProps(typ: any): any {
    if (typ.jsToJSON === undefined) {
        const map: any = {};
        typ.props.forEach((p: any) => map[p.js] = { key: p.json, typ: p.typ });
        typ.jsToJSON = map;
    }
    return typ.jsToJSON;
}

function transform(val: any, typ: any, getProps: any, key: any = '', parent: any = ''): any {
    function transformPrimitive(typ: string, val: any): any {
        if (typeof typ === typeof val) return val;
        return invalidValue(typ, val, key, parent);
    }

    function transformUnion(typs: any[], val: any): any {
        // val must validate against one typ in typs
        const l = typs.length;
        for (let i = 0; i < l; i++) {
            const typ = typs[i];
            try {
                return transform(val, typ, getProps);
            } catch (_) {}
        }
        return invalidValue(typs, val, key, parent);
    }

    function transformEnum(cases: string[], val: any): any {
        if (cases.indexOf(val) !== -1) return val;
        return invalidValue(cases.map(a => { return l(a); }), val, key, parent);
    }

    function transformArray(typ: any, val: any): any {
        // val must be an array with no invalid elements
        if (!Array.isArray(val)) return invalidValue(l("array"), val, key, parent);
        return val.map(el => transform(el, typ, getProps));
    }

    function transformDate(val: any): any {
        if (val === null) {
            return null;
        }
        const d = new Date(val);
        if (isNaN(d.valueOf())) {
            return invalidValue(l("Date"), val, key, parent);
        }
        return d;
    }

    function transformObject(props: { [k: string]: any }, additional: any, val: any): any {
        if (val === null || typeof val !== "object" || Array.isArray(val)) {
            return invalidValue(l(ref || "object"), val, key, parent);
        }
        const result: any = {};
        Object.getOwnPropertyNames(props).forEach(key => {
            const prop = props[key];
            const v = Object.prototype.hasOwnProperty.call(val, key) ? val[key] : undefined;
            result[prop.key] = transform(v, prop.typ, getProps, key, ref);
        });
        Object.getOwnPropertyNames(val).forEach(key => {
            if (!Object.prototype.hasOwnProperty.call(props, key)) {
                result[key] = transform(val[key], additional, getProps, key, ref);
            }
        });
        return result;
    }

    if (typ === "any") return val;
    if (typ === null) {
        if (val === null) return val;
        return invalidValue(typ, val, key, parent);
    }
    if (typ === false) return invalidValue(typ, val, key, parent);
    let ref: any = undefined;
    while (typeof typ === "object" && typ.ref !== undefined) {
        ref = typ.ref;
        typ = typeMap[typ.ref];
    }
    if (Array.isArray(typ)) return transformEnum(typ, val);
    if (typeof typ === "object") {
        return typ.hasOwnProperty("unionMembers") ? transformUnion(typ.unionMembers, val)
            : typ.hasOwnProperty("arrayItems")    ? transformArray(typ.arrayItems, val)
            : typ.hasOwnProperty("props")         ? transformObject(getProps(typ), typ.additional, val)
            : invalidValue(typ, val, key, parent);
    }
    // Numbers can be parsed by Date but shouldn't be.
    if (typ === Date && typeof val !== "number") return transformDate(val);
    return transformPrimitive(typ, val);
}

function cast<T>(val: any, typ: any): T {
    return transform(val, typ, jsonToJSProps);
}

function uncast<T>(val: T, typ: any): any {
    return transform(val, typ, jsToJSONProps);
}

function l(typ: any) {
    return { literal: typ };
}

function a(typ: any) {
    return { arrayItems: typ };
}

function u(...typs: any[]) {
    return { unionMembers: typs };
}

function o(props: any[], additional: any) {
    return { props, additional };
}

function m(additional: any) {
    return { props: [], additional };
}

function r(name: string) {
    return { ref: name };
}

const typeMap: any = {
    "AddApartmentBlockRequest": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "notes", js: "notes", typ: "" },
    ], false),
    "AddSavedGridViewRequest": o([
        { json: "id", js: "id", typ: u(undefined, 3.14) },
        { json: "viewName", js: "viewName", typ: "" },
        { json: "gridName", js: "gridName", typ: "" },
        { json: "columnStates", js: "columnStates", typ: a(r("ColumnState")) },
        { json: "filterModel", js: "filterModel", typ: u(undefined, m("any")) },
    ], false),
    "ColumnState": o([
        { json: "aggFunc", js: "aggFunc", typ: u(null, "") },
        { json: "colId", js: "colId", typ: "" },
        { json: "flex", js: "flex", typ: u(0, null) },
        { json: "hide", js: "hide", typ: true },
        { json: "pinned", js: "pinned", typ: u(r("Pinned"), null) },
        { json: "pivot", js: "pivot", typ: true },
        { json: "pivotIndex", js: "pivotIndex", typ: u(0, null) },
        { json: "rowGroup", js: "rowGroup", typ: true },
        { json: "rowGroupIndex", js: "rowGroupIndex", typ: u(0, null) },
        { json: "sort", js: "sort", typ: u(r("Sort"), null) },
        { json: "sortIndex", js: "sortIndex", typ: u(0, null) },
        { json: "width", js: "width", typ: 0 },
    ], "any"),
    "AddSavedGridViewResponse": o([
        { json: "gridView", js: "gridView", typ: r("GridView") },
    ], "any"),
    "GridView": o([
        { json: "columnStates", js: "columnStates", typ: a(r("ColumnState")) },
        { json: "filterModel", js: "filterModel", typ: u(undefined, m("any")) },
        { json: "gridName", js: "gridName", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "viewName", js: "viewName", typ: "" },
    ], "any"),
    "AddTagResponse": o([
        { json: "tag", js: "tag", typ: r("AddTagResponseTag") },
    ], false),
    "AddTagResponseTag": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetAddressesResponse": o([
        { json: "addresses", js: "addresses", typ: a(r("Address")) },
    ], false),
    "Address": o([
        { json: "canonical", js: "canonical", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "municipalitySectionId", js: "municipalitySectionId", typ: 3.14 },
        { json: "number", js: "number", typ: "" },
        { json: "postalCode", js: "postalCode", typ: "" },
        { json: "street", js: "street", typ: "" },
    ], false),
    "GetAddressesWithCountsResponse": o([
        { json: "addresses", js: "addresses", typ: a(r("AddressWithApartments")) },
    ], false),
    "AddressWithApartments": o([
        { json: "apartments", js: "apartments", typ: a(r("ApartmentAtAddress")) },
        { json: "canonical", js: "canonical", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "municipalitySectionId", js: "municipalitySectionId", typ: 3.14 },
        { json: "number", js: "number", typ: "" },
        { json: "postalCode", js: "postalCode", typ: "" },
        { json: "street", js: "street", typ: "" },
    ], false),
    "ApartmentAtAddress": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
    ], false),
    "GetAirbnbReviewsResponse": o([
        { json: "reviews", js: "reviews", typ: a(r("AirbnbReview")) },
    ], false),
    "AirbnbReview": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "date", js: "date", typ: Date },
        { json: "numberOfReviews", js: "numberOfReviews", typ: 0 },
        { json: "averageRating", js: "averageRating", typ: 3.14 },
        { json: "cleanliness", js: "cleanliness", typ: u(3.14, null) },
        { json: "accuracy", js: "accuracy", typ: u(3.14, null) },
        { json: "communication", js: "communication", typ: u(3.14, null) },
        { json: "checkIn", js: "checkIn", typ: u(3.14, null) },
        { json: "value", js: "value", typ: u(3.14, null) },
        { json: "location", js: "location", typ: u(3.14, null) },
        { json: "updateInProgress", js: "updateInProgress", typ: true },
    ], false),
    "GetAllTagsResponse": o([
        { json: "tags", js: "tags", typ: a(r("GetAllTagsResponseTag")) },
    ], false),
    "GetAllTagsResponseTag": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetAllUsersResponse": o([
        { json: "users", js: "users", typ: a(r("User")) },
    ], false),
    "User": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "givenName", js: "givenName", typ: "" },
        { json: "lastName", js: "lastName", typ: "" },
        { json: "email", js: "email", typ: "" },
        { json: "profileImageUri", js: "profileImageUri", typ: "" },
        { json: "isAdmin", js: "isAdmin", typ: true },
        { json: "visibleOwners", js: "visibleOwners", typ: a(3.14) },
        { json: "lastVisited", js: "lastVisited", typ: u(undefined, Date) },
    ], false),
    "GetApartmentBlocks": o([
        { json: "apartmentBlocks", js: "apartmentBlocks", typ: a(r("ApartmentBlockCalendarElement")) },
    ], false),
    "ApartmentBlockCalendarElement": o([
        { json: "apartmentId", js: "apartmentId", typ: u(undefined, 3.14) },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "id", js: "id", typ: u(undefined, 3.14) },
        { json: "notes", js: "notes", typ: u(undefined, "") },
        { json: "origin", js: "origin", typ: "" },
        { json: "reason", js: "reason", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "title", js: "title", typ: "" },
    ], false),
    "GetApartmentGroupsResponse": o([
        { json: "groups", js: "groups", typ: a(r("ApartmentGroup")) },
    ], false),
    "ApartmentGroup": o([
        { json: "description", js: "description", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetApartmentOwnerResponse": o([
        { json: "owner", js: "owner", typ: r("ApartmentOwner") },
    ], false),
    "ApartmentOwner": o([
        { json: "fullName", js: "fullName", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "taxId", js: "taxId", typ: u(undefined, "") },
        { json: "taxisPassword", js: "taxisPassword", typ: u(undefined, "") },
        { json: "taxisUserName", js: "taxisUserName", typ: u(undefined, "") },
    ], false),
    "GetApartmentOwnersResponse": o([
        { json: "owners", js: "owners", typ: a(r("ApartmentOwner")) },
    ], false),
    "GetApartmentResponse": o([
        { json: "apartment", js: "apartment", typ: r("Apartment") },
    ], false),
    "Apartment": o([
        { json: "address", js: "address", typ: u(undefined, "") },
        { json: "addressId", js: "addressId", typ: u(undefined, u(0, null)) },
        { json: "airbnbUrl", js: "airbnbUrl", typ: u(undefined, "") },
        { json: "atak", js: "atak", typ: u(undefined, "") },
        { json: "bookingUrl", js: "bookingUrl", typ: u(undefined, "") },
        { json: "categoryId", js: "categoryId", typ: 3.14 },
        { json: "checkInFeeRate", js: "checkInFeeRate", typ: 3.14 },
        { json: "dateAdded", js: "dateAdded", typ: Date },
        { json: "dateRemoved", js: "dateRemoved", typ: u(undefined, Date) },
        { json: "disinfectionCertificateNumber", js: "disinfectionCertificateNumber", typ: u(undefined, "") },
        { json: "disinfectionDate", js: "disinfectionDate", typ: u(undefined, Date) },
        { json: "electricityCertificateTerminationDate", js: "electricityCertificateTerminationDate", typ: u(undefined, Date) },
        { json: "electricityCompany", js: "electricityCompany", typ: u(undefined, "") },
        { json: "electricityRf", js: "electricityRf", typ: u(undefined, "") },
        { json: "electricitySupplyId", js: "electricitySupplyId", typ: u(undefined, "") },
        { json: "energyCertificateIssuanceDate", js: "energyCertificateIssuanceDate", typ: u(undefined, Date) },
        { json: "eydapRegistryId", js: "eydapRegistryId", typ: u(undefined, "") },
        { json: "eydapSupplyId", js: "eydapSupplyId", typ: u(undefined, "") },
        { json: "fireExtinguisherRefillCertificateDate", js: "fireExtinguisherRefillCertificateDate", typ: u(undefined, Date) },
        { json: "floor", js: "floor", typ: u(undefined, 3.14) },
        { json: "groupId", js: "groupId", typ: 3.14 },
        { json: "hosthubExcluded", js: "hosthubExcluded", typ: u(undefined, true) },
        { json: "hosthubRentalId", js: "hosthubRentalId", typ: u(undefined, "") },
        { json: "id", js: "id", typ: 3.14 },
        { json: "imageUrl", js: "imageUrl", typ: u(undefined, "") },
        { json: "initialTaxisRentalAgreement", js: "initialTaxisRentalAgreement", typ: u(undefined, "") },
        { json: "insuranceCompany", js: "insuranceCompany", typ: u(undefined, "") },
        { json: "insuranceContractId", js: "insuranceContractId", typ: u(undefined, "") },
        { json: "internetCompany", js: "internetCompany", typ: u(undefined, "") },
        { json: "internetLine", js: "internetLine", typ: u(undefined, "") },
        { json: "internetPassword", js: "internetPassword", typ: u(undefined, "") },
        { json: "internetUsername", js: "internetUsername", typ: u(undefined, "") },
        { json: "isExemptFromErpUpload", js: "isExemptFromErpUpload", typ: true },
        { json: "latestRentalTaxisAgreement", js: "latestRentalTaxisAgreement", typ: u(undefined, "") },
        { json: "municipalitySectionId", js: "municipalitySectionId", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
        { json: "neteraCredentialsId", js: "neteraCredentialsId", typ: u(undefined, u(0, null)) },
        { json: "numberOfBeds", js: "numberOfBeds", typ: u(undefined, 3.14) },
        { json: "ownerGroupId", js: "ownerGroupId", typ: 3.14 },
        { json: "ownerIds", js: "ownerIds", typ: a(3.14) },
        { json: "shortName", js: "shortName", typ: "" },
        { json: "shortTermPropertyId", js: "shortTermPropertyId", typ: u(undefined, 3.14) },
        { json: "shortTermRegistryId", js: "shortTermRegistryId", typ: "" },
        { json: "squareMeters", js: "squareMeters", typ: u(undefined, 3.14) },
        { json: "strOwnerId", js: "strOwnerId", typ: u(undefined, u(0, null)) },
        { json: "tagIds", js: "tagIds", typ: u(undefined, a(3.14)) },
        { json: "tags", js: "tags", typ: u(undefined, a(r("ApartmentTag"))) },
    ], false),
    "ApartmentTag": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetApartmentsResponse": o([
        { json: "apartments", js: "apartments", typ: a(r("Apartment")) },
    ], false),
    "GetApartmentStatTrends": o([
        { json: "apartmentStatTrends", js: "apartmentStatTrends", typ: a(r("ApartmentStatTrend")) },
    ], false),
    "ApartmentStatTrend": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "daysAvailable", js: "daysAvailable", typ: 3.14 },
        { json: "daysAvailablePreviousPeriod", js: "daysAvailablePreviousPeriod", typ: 3.14 },
        { json: "daysAvailablePreviousYear", js: "daysAvailablePreviousYear", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysBookedPreviousPeriod", js: "daysBookedPreviousPeriod", typ: 3.14 },
        { json: "daysBookedPreviousYear", js: "daysBookedPreviousYear", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossAdrPreviousPeriod", js: "grossAdrPreviousPeriod", typ: 3.14 },
        { json: "grossAdrPreviousYear", js: "grossAdrPreviousYear", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomePreviousPeriod", js: "grossIncomePreviousPeriod", typ: 3.14 },
        { json: "grossIncomePreviousYear", js: "grossIncomePreviousYear", typ: 3.14 },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netAdrPreviousPeriod", js: "netAdrPreviousPeriod", typ: 3.14 },
        { json: "netAdrPreviousYear", js: "netAdrPreviousYear", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomePreviousPeriod", js: "netIncomePreviousPeriod", typ: 3.14 },
        { json: "netIncomePreviousYear", js: "netIncomePreviousYear", typ: 3.14 },
        { json: "numberOfVisits", js: "numberOfVisits", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "occupancyPreviousPeriod", js: "occupancyPreviousPeriod", typ: 3.14 },
        { json: "occupancyPreviousYear", js: "occupancyPreviousYear", typ: 3.14 },
        { json: "payout", js: "payout", typ: 3.14 },
        { json: "payoutPreviousPeriod", js: "payoutPreviousPeriod", typ: 3.14 },
        { json: "payoutPreviousYear", js: "payoutPreviousYear", typ: 3.14 },
        { json: "payoutRatio", js: "payoutRatio", typ: 3.14 },
        { json: "payoutRatioPreviousPeriod", js: "payoutRatioPreviousPeriod", typ: 3.14 },
        { json: "payoutRatioPreviousYear", js: "payoutRatioPreviousYear", typ: 3.14 },
    ], false),
    "GetBltStatsResponse": o([
        { json: "bltStats", js: "bltStats", typ: a(r("BltStatsItem")) },
    ], false),
    "BltStatsItem": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "bookingsReceived", js: "bookingsReceived", typ: 3.14 },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "leadDaysGroup", js: "leadDaysGroup", typ: "" },
    ], false),
    "GetBookingPaceResponse": o([
        { json: "bookingPace", js: "bookingPace", typ: a(r("BookingPaceItem")) },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "startDate", js: "startDate", typ: Date },
    ], false),
    "BookingPaceItem": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "groupId", js: "groupId", typ: 3.14 },
        { json: "platformId", js: "platformId", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "futureDaysBooked", js: "futureDaysBooked", typ: 3.14 },
        { json: "bookingsReceived", js: "bookingsReceived", typ: 3.14 },
        { json: "futureGrossIncome", js: "futureGrossIncome", typ: 3.14 },
        { json: "futureNetIncome", js: "futureNetIncome", typ: 3.14 },
        { json: "cancelledBookings", js: "cancelledBookings", typ: 3.14 },
        { json: "cancelledDays", js: "cancelledDays", typ: 3.14 },
    ], false),
    "GetDashboardLayoutsResponse": o([
        { json: "layouts", js: "layouts", typ: a(r("DashboardLayout")) },
    ], false),
    "DashboardLayout": o([
        { json: "dashboardId", js: "dashboardId", typ: "" },
        { json: "id", js: "id", typ: 3.14 },
        { json: "layout", js: "layout", typ: m("any") },
        { json: "layoutName", js: "layoutName", typ: "" },
        { json: "userId", js: "userId", typ: 3.14 },
    ], false),
    "GetExpenseCategoriesResponse": o([
        { json: "expenseCategories", js: "expenseCategories", typ: a(r("ExpenseCategory")) },
    ], false),
    "ExpenseCategory": o([
        { json: "id", js: "id", typ: 0 },
        { json: "category", js: "category", typ: "" },
        { json: "description", js: "description", typ: "" },
    ], false),
    "GetExpensesResponse": o([
        { json: "expenses", js: "expenses", typ: a(r("Expense")) },
    ], false),
    "Expense": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "categoryId", js: "categoryId", typ: 0 },
        { json: "date", js: "date", typ: Date },
        { json: "amount", js: "amount", typ: 3.14 },
        { json: "notes", js: "notes", typ: "" },
    ], false),
    "GetGroupedByExpensesGroupResponse": o([
        { json: "expenses", js: "expenses", typ: a(r("GroupedGroupExpense")) },
    ], false),
    "GroupedGroupExpense": o([
        { json: "groupId", js: "groupId", typ: 0 },
        { json: "categoryId", js: "categoryId", typ: 0 },
        { json: "amount", js: "amount", typ: 3.14 },
    ], false),
    "GetGroupedByExpensesResponse": o([
        { json: "expenses", js: "expenses", typ: a(r("GroupedExpense")) },
    ], false),
    "GroupedExpense": o([
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "categoryId", js: "categoryId", typ: 0 },
        { json: "amount", js: "amount", typ: 3.14 },
    ], false),
    "GetHostHubMappingStatusResponse": o([
        { json: "unmappedApartments", js: "unmappedApartments", typ: a(r("HostHubUnmappedApartment")) },
        { json: "unmatchedRentals", js: "unmatchedRentals", typ: a(r("UnmatchedRentalElement")) },
    ], false),
    "HostHubUnmappedApartment": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "UnmatchedRentalElement": o([
        { json: "id", js: "id", typ: "" },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetHostHubRentalsResponse": o([
        { json: "rentals", js: "rentals", typ: a(r("RentalElement")) },
    ], false),
    "RentalElement": o([
        { json: "id", js: "id", typ: "" },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetHostHubSyncIssuesResponse": o([
        { json: "hasRun", js: "hasRun", typ: true },
        { json: "issues", js: "issues", typ: a(r("HostHubSyncIssue")) },
        { json: "lastRunAt", js: "lastRunAt", typ: u(undefined, Date) },
    ], false),
    "HostHubSyncIssue": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
        { json: "bookingRef", js: "bookingRef", typ: "" },
        { json: "eventType", js: "eventType", typ: "" },
        { json: "firstObservedAt", js: "firstObservedAt", typ: Date },
        { json: "reason", js: "reason", typ: "" },
        { json: "rentalId", js: "rentalId", typ: "" },
        { json: "waitingCount", js: "waitingCount", typ: 3.14 },
    ], false),
    "GetManagementFeeRatioResponse": o([
        { json: "managementFeeRatio", js: "managementFeeRatio", typ: r("ManagementFeeRatioClass") },
    ], false),
    "ManagementFeeRatioClass": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "managementFeeRatio", js: "managementFeeRatio", typ: 3.14 },
        { json: "fromDate", js: "fromDate", typ: Date },
    ], false),
    "GetManagementFeeRatiosResponse": o([
        { json: "managementFeeRatios", js: "managementFeeRatios", typ: a(r("ManagementFeeRatio")) },
    ], false),
    "ManagementFeeRatio": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "managementFeeRatio", js: "managementFeeRatio", typ: 3.14 },
        { json: "fromDate", js: "fromDate", typ: Date },
    ], false),
    "GetMonthlyApartmentStatsResponse": o([
        { json: "apartmentStats", js: "apartmentStats", typ: a(r("ApartmentStats")) },
        { json: "months", js: "months", typ: a(Date) },
        { json: "numberOfApartments", js: "numberOfApartments", typ: 3.14 },
    ], false),
    "ApartmentStats": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "availableBookingDays", js: "availableBookingDays", typ: 3.14 },
        { json: "averageBlt", js: "averageBlt", typ: 3.14 },
        { json: "averageLengthOfStay", js: "averageLengthOfStay", typ: 3.14 },
        { json: "businessFee", js: "businessFee", typ: 3.14 },
        { json: "cleaningFees", js: "cleaningFees", typ: 3.14 },
        { json: "daysBlocked", js: "daysBlocked", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysBookedForStartingInPeriod", js: "daysBookedForStartingInPeriod", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomeAdjusted", js: "grossIncomeAdjusted", typ: 3.14 },
        { json: "leadDays", js: "leadDays", typ: u(undefined, 3.14) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomeAdjusted", js: "netIncomeAdjusted", typ: 3.14 },
        { json: "numberOfReservationsReceived", js: "numberOfReservationsReceived", typ: 3.14 },
        { json: "numberOfVisits", js: "numberOfVisits", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "platformCommissions", js: "platformCommissions", typ: 3.14 },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "GetMunicipalitySectionsResponse": o([
        { json: "municipalitySections", js: "municipalitySections", typ: a(r("MunicipalitySection")) },
    ], false),
    "MunicipalitySection": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetMunicipalitySectionsWithCountsResponse": o([
        { json: "municipalitySections", js: "municipalitySections", typ: a(r("MunicipalitySectionElement")) },
    ], false),
    "MunicipalitySectionElement": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetNeedsRefileResponse": o([
        { json: "reservations", js: "reservations", typ: a(r("NeedsRefileItem")) },
    ], false),
    "NeedsRefileItem": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "isUploadedToMyData", js: "isUploadedToMyData", typ: true },
        { json: "reason", js: "reason", typ: "" },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "reservationId", js: "reservationId", typ: 3.14 },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "uploadedToShortTermRegistry", js: "uploadedToShortTermRegistry", typ: true },
    ], false),
    "GetNeteraAccountsResponse": o([
        { json: "accounts", js: "accounts", typ: a(r("AccountElement")) },
    ], false),
    "AccountElement": o([
        { json: "apiKeySet", js: "apiKeySet", typ: true },
        { json: "id", js: "id", typ: 0 },
        { json: "passwordChangedAt", js: "passwordChangedAt", typ: Date },
        { json: "targets", js: "targets", typ: a(r("AccountTarget")) },
        { json: "username", js: "username", typ: "" },
    ], false),
    "AccountTarget": o([
        { json: "apartmentCount", js: "apartmentCount", typ: 0 },
        { json: "branchId", js: "branchId", typ: "" },
        { json: "hotelId", js: "hotelId", typ: "" },
        { json: "id", js: "id", typ: 0 },
        { json: "label", js: "label", typ: "" },
    ], false),
    "GetNeteraCredentialLabelsResponse": o([
        { json: "labels", js: "labels", typ: a(r("NeteraCredentialLabel")) },
    ], false),
    "NeteraCredentialLabel": o([
        { json: "id", js: "id", typ: 0 },
        { json: "label", js: "label", typ: "" },
    ], false),
    "GetOccupanciesResponse": o([
        { json: "date", js: "date", typ: Date },
        { json: "occupancies", js: "occupancies", typ: a(r("OccupancyItem")) },
    ], false),
    "OccupancyItem": o([
        { json: "date", js: "date", typ: Date },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysAvailable", js: "daysAvailable", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
    ], false),
    "GetOverviewStatsResponse": o([
        { json: "overviewStats", js: "overviewStats", typ: r("OverviewStats") },
    ], "any"),
    "OverviewStats": o([
        { json: "groupStats", js: "groupStats", typ: a(r("GroupStat")) },
        { json: "totalStats", js: "totalStats", typ: r("TotalStatsClass") },
    ], "any"),
    "GroupStat": o([
        { json: "apartmentsInGroup", js: "apartmentsInGroup", typ: 3.14 },
        { json: "apartmentsInGroupPrevious", js: "apartmentsInGroupPrevious", typ: 3.14 },
        { json: "apartmentsInGroupPreviousYear", js: "apartmentsInGroupPreviousYear", typ: 3.14 },
        { json: "averageLengthOfStay", js: "averageLengthOfStay", typ: 3.14 },
        { json: "averageLengthOfStayPrevious", js: "averageLengthOfStayPrevious", typ: 3.14 },
        { json: "averageLengthOfStayPreviousYear", js: "averageLengthOfStayPreviousYear", typ: 3.14 },
        { json: "blt", js: "blt", typ: 3.14 },
        { json: "bltPrevious", js: "bltPrevious", typ: 3.14 },
        { json: "bltPreviousYear", js: "bltPreviousYear", typ: 3.14 },
        { json: "bookingsReceived", js: "bookingsReceived", typ: 0 },
        { json: "bookingsReceivedPrevious", js: "bookingsReceivedPrevious", typ: 0 },
        { json: "bookingsReceivedPreviousYear", js: "bookingsReceivedPreviousYear", typ: 0 },
        { json: "daysBooked", js: "daysBooked", typ: 0 },
        { json: "daysBookedPrevious", js: "daysBookedPrevious", typ: 0 },
        { json: "daysBookedPreviousYear", js: "daysBookedPreviousYear", typ: 0 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossAdrPrevious", js: "grossAdrPrevious", typ: 3.14 },
        { json: "grossAdrPreviousYear", js: "grossAdrPreviousYear", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomePrevious", js: "grossIncomePrevious", typ: 3.14 },
        { json: "grossIncomePreviousYear", js: "grossIncomePreviousYear", typ: 3.14 },
        { json: "groupId", js: "groupId", typ: 3.14 },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netAdrPrevious", js: "netAdrPrevious", typ: 3.14 },
        { json: "netAdrPreviousYear", js: "netAdrPreviousYear", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomePrevious", js: "netIncomePrevious", typ: 3.14 },
        { json: "netIncomePreviousYear", js: "netIncomePreviousYear", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "occupancyPrevious", js: "occupancyPrevious", typ: 3.14 },
        { json: "occupancyPreviousYear", js: "occupancyPreviousYear", typ: 3.14 },
    ], "any"),
    "TotalStatsClass": o([
        { json: "availableBookingDays", js: "availableBookingDays", typ: 3.14 },
        { json: "averageBlt", js: "averageBlt", typ: 3.14 },
        { json: "averageLengthOfStay", js: "averageLengthOfStay", typ: 3.14 },
        { json: "businessFee", js: "businessFee", typ: 3.14 },
        { json: "cleaningFees", js: "cleaningFees", typ: 3.14 },
        { json: "daysBlocked", js: "daysBlocked", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysBookedForStartingInPeriod", js: "daysBookedForStartingInPeriod", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomeAdjusted", js: "grossIncomeAdjusted", typ: 3.14 },
        { json: "leadDays", js: "leadDays", typ: u(undefined, 3.14) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomeAdjusted", js: "netIncomeAdjusted", typ: 3.14 },
        { json: "numberOfReservationsReceived", js: "numberOfReservationsReceived", typ: 3.14 },
        { json: "numberOfVisits", js: "numberOfVisits", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "platformCommissions", js: "platformCommissions", typ: 3.14 },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "GetOwnerAirbnbReviewsResponse": o([
        { json: "reviews", js: "reviews", typ: a(r("OwnerAirbnbReview")) },
    ], false),
    "OwnerAirbnbReview": o([
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "date", js: "date", typ: Date },
        { json: "numberOfReviews", js: "numberOfReviews", typ: 0 },
        { json: "overallScore", js: "overallScore", typ: 3.14 },
    ], false),
    "GetOwnerGroupsResponse": o([
        { json: "ownerGroups", js: "ownerGroups", typ: a(r("OwnerGroup")) },
    ], false),
    "OwnerGroup": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "monthlyFee", js: "monthlyFee", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetOwnerGroupsWithCountsResponse": o([
        { json: "ownerGroups", js: "ownerGroups", typ: a(r("OwnerGroupElement")) },
    ], false),
    "OwnerGroupElement": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "monthlyFee", js: "monthlyFee", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetPayoutRatioResponse": o([
        { json: "payoutRatio", js: "payoutRatio", typ: r("PayoutRatioClass") },
    ], false),
    "PayoutRatioClass": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "payoutRatio", js: "payoutRatio", typ: 3.14 },
        { json: "fromDate", js: "fromDate", typ: Date },
    ], false),
    "GetPayoutRatiosResponse": o([
        { json: "payoutRatios", js: "payoutRatios", typ: a(r("PayoutRatio")) },
    ], false),
    "PayoutRatio": o([
        { json: "id", js: "id", typ: 0 },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "payoutRatio", js: "payoutRatio", typ: 3.14 },
        { json: "fromDate", js: "fromDate", typ: Date },
    ], false),
    "GetPayoutsReponse": o([
        { json: "payoutStats", js: "payoutStats", typ: a(r("PayoutStat")) },
    ], false),
    "PayoutStat": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "cumulativeDeposit", js: "cumulativeDeposit", typ: 3.14 },
        { json: "deposit", js: "deposit", typ: 3.14 },
        { json: "expenses", js: "expenses", typ: 3.14 },
        { json: "fromDate", js: "fromDate", typ: Date },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "managementFee", js: "managementFee", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "payout", js: "payout", typ: 3.14 },
        { json: "payoutRatio", js: "payoutRatio", typ: 3.14 },
        { json: "toDate", js: "toDate", typ: Date },
    ], "any"),
    "GetPayoutStatsResponse": o([
        { json: "payoutStats", js: "payoutStats", typ: a(r("PayoutStat")) },
    ], false),
    "GetPeriodBreakdownStatsResponse": o([
        { json: "periodBreakdownStats", js: "periodBreakdownStats", typ: r("PeriodBreakdownStats") },
    ], "any"),
    "PeriodBreakdownStats": o([
        { json: "apartmentStats", js: "apartmentStats", typ: a(a(r("ApartmentStats"))) },
        { json: "periodNames", js: "periodNames", typ: a("") },
    ], "any"),
    "GetReservationDigestResponse": o([
        { json: "days", js: "days", typ: a(r("DigestDay")) },
        { json: "lastSyncedAt", js: "lastSyncedAt", typ: u(undefined, Date) },
        { json: "rangeTotals", js: "rangeTotals", typ: r("DigestTotals") },
    ], false),
    "DigestDay": o([
        { json: "blocks", js: "blocks", typ: r("DigestBlocks") },
        { json: "cancellations", js: "cancellations", typ: a(r("DigestItem")) },
        { json: "date", js: "date", typ: Date },
        { json: "modifications", js: "modifications", typ: a(r("DigestItem")) },
        { json: "newBookings", js: "newBookings", typ: a(r("DigestItem")) },
        { json: "totals", js: "totals", typ: r("DigestTotals") },
    ], false),
    "DigestBlocks": o([
        { json: "added", js: "added", typ: a(r("DigestBlockItem")) },
        { json: "housekeepingCount", js: "housekeepingCount", typ: 3.14 },
        { json: "removed", js: "removed", typ: a(r("DigestBlockItem")) },
    ], false),
    "DigestBlockItem": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
        { json: "blockId", js: "blockId", typ: 3.14 },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "hasConflict", js: "hasConflict", typ: true },
        { json: "nights", js: "nights", typ: 3.14 },
        { json: "origin", js: "origin", typ: "" },
        { json: "reason", js: "reason", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "status", js: "status", typ: "" },
        { json: "title", js: "title", typ: "" },
        { json: "versionId", js: "versionId", typ: 3.14 },
    ], false),
    "DigestItem": o([
        { json: "adr", js: "adr", typ: u(undefined, 3.14) },
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
        { json: "bookedOn", js: "bookedOn", typ: Date },
        { json: "cancelledAt", js: "cancelledAt", typ: u(undefined, Date) },
        { json: "changes", js: "changes", typ: u(undefined, a(r("DigestChange"))) },
        { json: "checkIn", js: "checkIn", typ: Date },
        { json: "checkOut", js: "checkOut", typ: Date },
        { json: "guestName", js: "guestName", typ: "" },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "nights", js: "nights", typ: 3.14 },
        { json: "platform", js: "platform", typ: 3.14 },
        { json: "receivableIncome", js: "receivableIncome", typ: 3.14 },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "reservationId", js: "reservationId", typ: 3.14 },
        { json: "status", js: "status", typ: "" },
        { json: "versionId", js: "versionId", typ: 3.14 },
    ], false),
    "DigestChange": o([
        { json: "field", js: "field", typ: "" },
        { json: "from", js: "from", typ: "" },
        { json: "to", js: "to", typ: "" },
    ], false),
    "DigestTotals": o([
        { json: "blocksCount", js: "blocksCount", typ: 3.14 },
        { json: "cancellationsCount", js: "cancellationsCount", typ: 3.14 },
        { json: "cancelledNights", js: "cancelledNights", typ: u(undefined, 3.14) },
        { json: "modificationsCount", js: "modificationsCount", typ: 3.14 },
        { json: "newBookingsCount", js: "newBookingsCount", typ: 3.14 },
        { json: "nights", js: "nights", typ: 3.14 },
        { json: "revenue", js: "revenue", typ: 3.14 },
    ], false),
    "GetReservationHistoryResponse": o([
        { json: "history", js: "history", typ: a(r("ReservationVersion")) },
    ], false),
    "ReservationVersion": o([
        { json: "actualDaysOfStay", js: "actualDaysOfStay", typ: 3.14 },
        { json: "amountPaid", js: "amountPaid", typ: u(undefined, 3.14) },
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "bookingDate", js: "bookingDate", typ: Date },
        { json: "cancelledAt", js: "cancelledAt", typ: u(undefined, Date) },
        { json: "changeReason", js: "changeReason", typ: u(undefined, "") },
        { json: "changeSource", js: "changeSource", typ: "" },
        { json: "cleanerId", js: "cleanerId", typ: u(undefined, 3.14) },
        { json: "cleaningCost", js: "cleaningCost", typ: u(undefined, 3.14) },
        { json: "cleaningFee", js: "cleaningFee", typ: u(undefined, 3.14) },
        { json: "cleaningOverridden", js: "cleaningOverridden", typ: true },
        { json: "commission", js: "commission", typ: 3.14 },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "epsilon", js: "epsilon", typ: true },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "guestId", js: "guestId", typ: u(undefined, "") },
        { json: "guestName", js: "guestName", typ: "" },
        { json: "hosthubEventUpdated", js: "hosthubEventUpdated", typ: u(undefined, 3.14) },
        { json: "hostingExpense", js: "hostingExpense", typ: u(undefined, 3.14) },
        { json: "id", js: "id", typ: 3.14 },
        { json: "isCancelled", js: "isCancelled", typ: u(undefined, true) },
        { json: "isSyncFrozen", js: "isSyncFrozen", typ: u(undefined, true) },
        { json: "isTaxExempt", js: "isTaxExempt", typ: true },
        { json: "managementFee", js: "managementFee", typ: 3.14 },
        { json: "needsRefile", js: "needsRefile", typ: u(undefined, true) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "numberOfGuests", js: "numberOfGuests", typ: 3.14 },
        { json: "origin", js: "origin", typ: u(undefined, "") },
        { json: "paymentDate", js: "paymentDate", typ: u(undefined, Date) },
        { json: "payout", js: "payout", typ: 3.14 },
        { json: "platform", js: "platform", typ: 3.14 },
        { json: "receivableIncome", js: "receivableIncome", typ: 3.14 },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "uploadedToShortTermRegistry", js: "uploadedToShortTermRegistry", typ: true },
        { json: "vat", js: "vat", typ: 3.14 },
        { json: "versionCreatedAt", js: "versionCreatedAt", typ: Date },
        { json: "versionId", js: "versionId", typ: 3.14 },
    ], false),
    "GetReservationsResponse": o([
        { json: "reservations", js: "reservations", typ: a(r("ReservationElement")) },
    ], false),
    "ReservationElement": o([
        { json: "actualDaysOfStay", js: "actualDaysOfStay", typ: 3.14 },
        { json: "amountPaid", js: "amountPaid", typ: u(undefined, 3.14) },
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "bookingDate", js: "bookingDate", typ: Date },
        { json: "cancelledAt", js: "cancelledAt", typ: u(undefined, Date) },
        { json: "changeReason", js: "changeReason", typ: u(undefined, "") },
        { json: "cleanerId", js: "cleanerId", typ: u(undefined, 3.14) },
        { json: "cleaningCost", js: "cleaningCost", typ: u(undefined, 3.14) },
        { json: "cleaningFee", js: "cleaningFee", typ: u(undefined, 3.14) },
        { json: "cleaningOverridden", js: "cleaningOverridden", typ: true },
        { json: "commission", js: "commission", typ: 3.14 },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "epsilon", js: "epsilon", typ: true },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "guestId", js: "guestId", typ: u(undefined, "") },
        { json: "guestName", js: "guestName", typ: "" },
        { json: "hostingExpense", js: "hostingExpense", typ: u(undefined, 3.14) },
        { json: "id", js: "id", typ: 3.14 },
        { json: "isCancelled", js: "isCancelled", typ: u(undefined, true) },
        { json: "isSyncFrozen", js: "isSyncFrozen", typ: u(undefined, true) },
        { json: "isTaxExempt", js: "isTaxExempt", typ: true },
        { json: "managementFee", js: "managementFee", typ: 3.14 },
        { json: "needsRefile", js: "needsRefile", typ: u(undefined, true) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "numberOfGuests", js: "numberOfGuests", typ: 3.14 },
        { json: "origin", js: "origin", typ: u(undefined, "") },
        { json: "paymentDate", js: "paymentDate", typ: u(undefined, Date) },
        { json: "payout", js: "payout", typ: 3.14 },
        { json: "platform", js: "platform", typ: 3.14 },
        { json: "receivableIncome", js: "receivableIncome", typ: 3.14 },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "uploadedToShortTermRegistry", js: "uploadedToShortTermRegistry", typ: true },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "GetReviewPerformanceResponse": o([
        { json: "periodLabel", js: "periodLabel", typ: "" },
        { json: "rows", js: "rows", typ: a(r("ReviewPerformanceRow")) },
        { json: "showPreviousPeriod", js: "showPreviousPeriod", typ: true },
        { json: "showPreviousYear", js: "showPreviousYear", typ: true },
    ], false),
    "ReviewPerformanceRow": o([
        { json: "accuracy", js: "accuracy", typ: r("ReviewPerformanceCell") },
        { json: "apartmentId", js: "apartmentId", typ: 0 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
        { json: "baselineDate", js: "baselineDate", typ: u(null, "") },
        { json: "checkIn", js: "checkIn", typ: r("ReviewPerformanceCell") },
        { json: "cleanliness", js: "cleanliness", typ: r("ReviewPerformanceCell") },
        { json: "communication", js: "communication", typ: r("ReviewPerformanceCell") },
        { json: "location", js: "location", typ: r("ReviewPerformanceCell") },
        { json: "newReviews", js: "newReviews", typ: u(0, null) },
        { json: "newReviewsReason", js: "newReviewsReason", typ: u(null, "") },
        { json: "observedDate", js: "observedDate", typ: u(null, "") },
        { json: "overall", js: "overall", typ: r("ReviewPerformanceCell") },
        { json: "rowStatus", js: "rowStatus", typ: "" },
        { json: "totalReviews", js: "totalReviews", typ: u(0, null) },
        { json: "value", js: "value", typ: r("ReviewPerformanceCell") },
    ], false),
    "ReviewPerformanceCell": o([
        { json: "cohort", js: "cohort", typ: u(3.14, null) },
        { json: "cohortReason", js: "cohortReason", typ: u(null, "") },
        { json: "driftVsPrevPeriod", js: "driftVsPrevPeriod", typ: u(3.14, null) },
        { json: "driftVsPrevPeriodReason", js: "driftVsPrevPeriodReason", typ: u(null, "") },
        { json: "driftVsPrevYear", js: "driftVsPrevYear", typ: u(3.14, null) },
        { json: "driftVsPrevYearReason", js: "driftVsPrevYearReason", typ: u(null, "") },
        { json: "lifetime", js: "lifetime", typ: u(3.14, null) },
    ], false),
    "GetSavedGridViewsResponse": o([
        { json: "views", js: "views", typ: a(r("GridView")) },
    ], false),
    "GetShortTermRegistryRecordsResponse": o([
        { json: "strUploadResults", js: "strUploadResults", typ: a(r("StrUploadResult")) },
        { json: "taskId", js: "taskId", typ: 3.14 },
    ], "any"),
    "StrUploadResult": o([
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "status", js: "status", typ: r("StrUploadResultStatus") },
        { json: "text", js: "text", typ: "" },
    ], "any"),
    "GetStatsForApartmentsResponse": o([
        { json: "apartmentStats", js: "apartmentStats", typ: a(r("ApartmentStats")) },
    ], false),
    "GetStatsForApartmentsWithDates": o([
        { json: "apartmentStats", js: "apartmentStats", typ: a(r("ApartmentStats")) },
    ], false),
    "GetStatsForGroupsResponse": o([
        { json: "fromDate", js: "fromDate", typ: Date },
        { json: "groupStats", js: "groupStats", typ: a(r("GroupStats")) },
        { json: "toDate", js: "toDate", typ: Date },
    ], false),
    "GroupStats": o([
        { json: "availableBookingDays", js: "availableBookingDays", typ: 3.14 },
        { json: "averageBlt", js: "averageBlt", typ: 3.14 },
        { json: "averageLengthOfStay", js: "averageLengthOfStay", typ: 3.14 },
        { json: "businessFee", js: "businessFee", typ: 3.14 },
        { json: "cleaningFees", js: "cleaningFees", typ: 3.14 },
        { json: "daysBlocked", js: "daysBlocked", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysBookedForStartingInPeriod", js: "daysBookedForStartingInPeriod", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomeAdjusted", js: "grossIncomeAdjusted", typ: 3.14 },
        { json: "groupId", js: "groupId", typ: 3.14 },
        { json: "leadDays", js: "leadDays", typ: u(undefined, 3.14) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomeAdjusted", js: "netIncomeAdjusted", typ: 3.14 },
        { json: "numberOfApartments", js: "numberOfApartments", typ: 3.14 },
        { json: "numberOfReservationsReceived", js: "numberOfReservationsReceived", typ: 3.14 },
        { json: "numberOfVisits", js: "numberOfVisits", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "platformCommissions", js: "platformCommissions", typ: 3.14 },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "GetStrOwnersResponse": o([
        { json: "defaultOwnerId", js: "defaultOwnerId", typ: 0 },
        { json: "owners", js: "owners", typ: a(r("StrOwnerLabel")) },
    ], false),
    "StrOwnerLabel": o([
        { json: "id", js: "id", typ: 0 },
        { json: "name", js: "name", typ: "" },
        { json: "taxisUsername", js: "taxisUsername", typ: "" },
    ], false),
    "GetTagsWithCountsResponse": o([
        { json: "tags", js: "tags", typ: a(r("TagElement")) },
    ], false),
    "TagElement": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "GetTotalStatsResponse": o([
        { json: "fromDate", js: "fromDate", typ: Date },
        { json: "numberOfApartments", js: "numberOfApartments", typ: 3.14 },
        { json: "toDate", js: "toDate", typ: Date },
        { json: "totalStats", js: "totalStats", typ: r("TotalStats") },
    ], false),
    "TotalStats": o([
        { json: "availableBookingDays", js: "availableBookingDays", typ: 3.14 },
        { json: "averageBlt", js: "averageBlt", typ: 3.14 },
        { json: "averageLengthOfStay", js: "averageLengthOfStay", typ: 3.14 },
        { json: "businessFee", js: "businessFee", typ: 3.14 },
        { json: "cleaningFees", js: "cleaningFees", typ: 3.14 },
        { json: "daysBlocked", js: "daysBlocked", typ: 3.14 },
        { json: "daysBooked", js: "daysBooked", typ: 3.14 },
        { json: "daysBookedForStartingInPeriod", js: "daysBookedForStartingInPeriod", typ: 3.14 },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "grossIncome", js: "grossIncome", typ: 3.14 },
        { json: "grossIncomeAdjusted", js: "grossIncomeAdjusted", typ: 3.14 },
        { json: "leadDays", js: "leadDays", typ: u(undefined, 3.14) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "netIncomeAdjusted", js: "netIncomeAdjusted", typ: 3.14 },
        { json: "numberOfReservationsReceived", js: "numberOfReservationsReceived", typ: 3.14 },
        { json: "numberOfVisits", js: "numberOfVisits", typ: 3.14 },
        { json: "occupancy", js: "occupancy", typ: 3.14 },
        { json: "platformCommissions", js: "platformCommissions", typ: 3.14 },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "GetUserResponse": o([
        { json: "user", js: "user", typ: r("User") },
    ], "any"),
    "GetYearsInOperationResponse": o([
        { json: "years", js: "years", typ: a(0) },
    ], false),
    "ImportExpensesResponse": o([
        { json: "importExpensesResult", js: "importExpensesResult", typ: r("ImportExpensesResult") },
    ], "any"),
    "ImportExpensesResult": o([
        { json: "DeletedExpenseItems", js: "DeletedExpenseItems", typ: 0 },
        { json: "newExpenseItems", js: "newExpenseItems", typ: 0 },
    ], "any"),
    "MunicipalitySectionInUseError": o([
        { json: "errors", js: "errors", typ: a(r("MunicipalitySectionInUseErrorEntry")) },
    ], false),
    "MunicipalitySectionInUseErrorEntry": o([
        { json: "blockingApartments", js: "blockingApartments", typ: a(r("PurpleBlockingApartmentEntry")) },
        { json: "message", js: "message", typ: "" },
    ], false),
    "PurpleBlockingApartmentEntry": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
    ], false),
    "MunicipalitySectionWithCount": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "NeteraAccount": o([
        { json: "apiKeySet", js: "apiKeySet", typ: true },
        { json: "id", js: "id", typ: 0 },
        { json: "passwordChangedAt", js: "passwordChangedAt", typ: Date },
        { json: "targets", js: "targets", typ: a(r("NeteraAccountTarget")) },
        { json: "username", js: "username", typ: "" },
    ], false),
    "NeteraAccountTarget": o([
        { json: "apartmentCount", js: "apartmentCount", typ: 0 },
        { json: "branchId", js: "branchId", typ: "" },
        { json: "hotelId", js: "hotelId", typ: "" },
        { json: "id", js: "id", typ: 0 },
        { json: "label", js: "label", typ: "" },
    ], false),
    "OwnerGroupInUseError": o([
        { json: "errors", js: "errors", typ: a(r("OwnerGroupInUseErrorEntry")) },
    ], false),
    "OwnerGroupInUseErrorEntry": o([
        { json: "blockingApartments", js: "blockingApartments", typ: a(r("FluffyBlockingApartmentEntry")) },
        { json: "message", js: "message", typ: "" },
    ], false),
    "FluffyBlockingApartmentEntry": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
    ], false),
    "OwnerGroupWithCount": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "monthlyFee", js: "monthlyFee", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "ReconciliationResponse": o([
        { json: "result", js: "result", typ: r("ReconciliationResult") },
    ], false),
    "ReconciliationResult": o([
        { json: "cancelledOnly", js: "cancelledOnly", typ: a(r("CancelledOnlyElement")) },
        { json: "excelOnly", js: "excelOnly", typ: a(r("ExcelReservationRow")) },
        { json: "hosthubOnly", js: "hosthubOnly", typ: a(r("CancelledOnlyElement")) },
        { json: "matchedDiffering", js: "matchedDiffering", typ: a(r("MatchedDifference")) },
        { json: "matchedEqual", js: "matchedEqual", typ: a(r("MatchedPair")) },
    ], false),
    "CancelledOnlyElement": o([
        { json: "actualDaysOfStay", js: "actualDaysOfStay", typ: 3.14 },
        { json: "amountPaid", js: "amountPaid", typ: u(undefined, 3.14) },
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "bookingDate", js: "bookingDate", typ: Date },
        { json: "cancelledAt", js: "cancelledAt", typ: u(undefined, Date) },
        { json: "changeReason", js: "changeReason", typ: u(undefined, "") },
        { json: "cleanerId", js: "cleanerId", typ: u(undefined, 3.14) },
        { json: "cleaningCost", js: "cleaningCost", typ: u(undefined, 3.14) },
        { json: "cleaningFee", js: "cleaningFee", typ: u(undefined, 3.14) },
        { json: "cleaningOverridden", js: "cleaningOverridden", typ: true },
        { json: "commission", js: "commission", typ: 3.14 },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "epsilon", js: "epsilon", typ: true },
        { json: "grossAdr", js: "grossAdr", typ: 3.14 },
        { json: "guestId", js: "guestId", typ: u(undefined, "") },
        { json: "guestName", js: "guestName", typ: "" },
        { json: "hostingExpense", js: "hostingExpense", typ: u(undefined, 3.14) },
        { json: "id", js: "id", typ: 3.14 },
        { json: "isCancelled", js: "isCancelled", typ: u(undefined, true) },
        { json: "isSyncFrozen", js: "isSyncFrozen", typ: u(undefined, true) },
        { json: "isTaxExempt", js: "isTaxExempt", typ: true },
        { json: "managementFee", js: "managementFee", typ: 3.14 },
        { json: "needsRefile", js: "needsRefile", typ: u(undefined, true) },
        { json: "netAdr", js: "netAdr", typ: 3.14 },
        { json: "netIncome", js: "netIncome", typ: 3.14 },
        { json: "numberOfGuests", js: "numberOfGuests", typ: 3.14 },
        { json: "origin", js: "origin", typ: u(undefined, "") },
        { json: "paymentDate", js: "paymentDate", typ: u(undefined, Date) },
        { json: "payout", js: "payout", typ: 3.14 },
        { json: "platform", js: "platform", typ: 3.14 },
        { json: "receivableIncome", js: "receivableIncome", typ: 3.14 },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
        { json: "sustainabilityFee", js: "sustainabilityFee", typ: 3.14 },
        { json: "temporaryStayDuty", js: "temporaryStayDuty", typ: 3.14 },
        { json: "uploadedToShortTermRegistry", js: "uploadedToShortTermRegistry", typ: true },
        { json: "vat", js: "vat", typ: 3.14 },
    ], false),
    "ExcelReservationRow": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "endDate", js: "endDate", typ: Date },
        { json: "guestName", js: "guestName", typ: "" },
        { json: "nights", js: "nights", typ: 3.14 },
        { json: "platform", js: "platform", typ: 3.14 },
        { json: "receivableIncome", js: "receivableIncome", typ: 3.14 },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "startDate", js: "startDate", typ: Date },
    ], false),
    "MatchedDifference": o([
        { json: "differences", js: "differences", typ: a(r("FieldDifference")) },
        { json: "excel", js: "excel", typ: r("ExcelReservationRow") },
        { json: "hosthub", js: "hosthub", typ: r("CancelledOnlyElement") },
    ], false),
    "FieldDifference": o([
        { json: "excelValue", js: "excelValue", typ: "" },
        { json: "field", js: "field", typ: "" },
        { json: "hosthubValue", js: "hosthubValue", typ: "" },
    ], false),
    "MatchedPair": o([
        { json: "excel", js: "excel", typ: r("ExcelReservationRow") },
        { json: "hosthub", js: "hosthub", typ: r("CancelledOnlyElement") },
    ], false),
    "Tag": o([
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "TagInUseError": o([
        { json: "errors", js: "errors", typ: a(r("TagInUseErrorEntry")) },
    ], false),
    "TagInUseErrorEntry": o([
        { json: "blockingApartments", js: "blockingApartments", typ: a(r("TentacledBlockingApartmentEntry")) },
        { json: "message", js: "message", typ: "" },
    ], false),
    "TentacledBlockingApartmentEntry": o([
        { json: "apartmentId", js: "apartmentId", typ: 3.14 },
        { json: "apartmentName", js: "apartmentName", typ: "" },
    ], false),
    "TagWithCount": o([
        { json: "activeApartmentCount", js: "activeApartmentCount", typ: 3.14 },
        { json: "id", js: "id", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "UploadToMyDataResponse": o([
        { json: "myDataUploadResponse", js: "myDataUploadResponse", typ: a(r("MyDataUploadResponse")) },
    ], false),
    "MyDataUploadResponse": o([
        { json: "error", js: "error", typ: "" },
        { json: "invoiceUUID", js: "invoiceUUID", typ: "" },
        { json: "reservationCode", js: "reservationCode", typ: "" },
        { json: "status", js: "status", typ: r("MyDataUploadResponseStatus") },
        { json: "taxInvoiceUUID", js: "taxInvoiceUUID", typ: "" },
    ], false),
    "UploadToShortTermRegistryResponse": o([
        { json: "taskId", js: "taskId", typ: 3.14 },
    ], "any"),
    "UpsertDashboardLayoutResponse": o([
        { json: "layout", js: "layout", typ: r("DashboardLayout") },
    ], false),
    "AddMunicipalitySectionRequest": o([
        { json: "name", js: "name", typ: "" },
    ], false),
    "AddOwnerGroupRequest": o([
        { json: "monthlyFee", js: "monthlyFee", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "AddTagRequest": o([
        { json: "name", js: "name", typ: "" },
    ], false),
    "CreateNeteraAccountRequest": o([
        { json: "apiKey", js: "apiKey", typ: "" },
        { json: "password", js: "password", typ: "" },
        { json: "targets", js: "targets", typ: a(r("NewNeteraTarget")) },
        { json: "username", js: "username", typ: "" },
    ], false),
    "NewNeteraTarget": o([
        { json: "branchId", js: "branchId", typ: "" },
        { json: "hotelId", js: "hotelId", typ: "" },
        { json: "label", js: "label", typ: "" },
    ], false),
    "UpdateMunicipalitySectionRequest": o([
        { json: "name", js: "name", typ: "" },
    ], false),
    "UpdateOwnerGroupRequest": o([
        { json: "monthlyFee", js: "monthlyFee", typ: 3.14 },
        { json: "name", js: "name", typ: "" },
    ], false),
    "UpdateTagRequest": o([
        { json: "name", js: "name", typ: "" },
    ], false),
    "UpsertDashboardLayoutRequest": o([
        { json: "id", js: "id", typ: u(undefined, 3.14) },
        { json: "dashboardId", js: "dashboardId", typ: "" },
        { json: "layoutName", js: "layoutName", typ: "" },
        { json: "layout", js: "layout", typ: m("any") },
    ], false),
    "Pinned": [
        "left",
        "right",
    ],
    "Sort": [
        "asc",
        "desc",
    ],
    "StrUploadResultStatus": [
        "error",
        "pending",
        "success",
    ],
    "MyDataUploadResponseStatus": [
        "already-filed",
        "failed",
        "filed",
        "needs-reconciliation",
    ],
};
